{
  "app": {
    "name": "Molvia"
  },
  "outdated": {
    "line": "This browser is out of date — open Molvia in a recent Chrome, Safari, Firefox or Edge"
  },
  "nav": {
    "label": "Sections",
    "advice": "What to buy",
    "verdicts": "Ratings",
    "back_label": "Back",
    "money": "Money",
    "settings": "Settings",
    "purchases": "Purchases"
  },
  "state": {
    "loading": "Loading…",
    "retry": "Try again",
    "retrying": "Trying again…",
    "report": "Report a problem"
  },
  "trip": {
    "title": "Entry",
    "add_item": "Add an item",
    "add_short": "Item",
    "add_lead": "Add an",
    "scan_short": "Barcode",
    "scan_lead": "Scan",
    "unpriced": "no price",
    "total": "Total",
    "total_line": "Priced — {priced} of {total} · unpriced — {unpriced}",
    "receipt": {
      "total": "Total by receipt",
      "add": "+ Receipt total",
      "edit": "Change the receipt total",
      "line_prices": "by prices {amount}",
      "line_prices_part": "by prices {amount} — {n} of {total}",
      "line_meets": "matches the receipt",
      "line_over": "the receipt is {amount} less than the prices",
      "line_under": "the receipt is {amount} more than the prices",
      "line_unpriced": "no price — {amount}",
      "line_none": "no prices yet",
      "line_pending": "prices will be counted again once the items are sent",
      "sending": "Receipt total {amount} · sending",
      "removing": "Receipt total being removed · sending",
      "sheet": {
        "title": "Receipt total",
        "body": "The prices of the purchases stay as they are",
        "label": "Amount",
        "save": "Save",
        "remove": "Remove the total"
      },
      "finish": {
        "body": "{n} of {total} have no price. Enter what the receipt came to, and “Money” gets the whole of it",
        "label": "What did the receipt come to?"
      }
    },
    "unit_price": "{amount} per {unit}",
    "items_count": "{n} item | {n} items",
    "footnote": "Only the item is required. The price and the amount can be filled in later — the entry is never blocked",
    "finish": "Finish",
    "finish_confirm": {
      "title": "Finish this entry?",
      "body": "The items stay recorded. Anything forgotten can be added later",
      "body_receipt": "The receipt total {amount} stays in “Money”. Items can be added later",
      "ok": "Finish",
      "cancel": "Cancel"
    },
    "remove": {
      "action": "Delete the entry",
      "sheet": {
        "title": "Delete this entry?",
        "body": "The purchases and prices go, from “Money” and the accounts too. The ratings stay",
        "body_receipt": "The receipt total {amount} goes from “Money” and the accounts"
      },
      "empty": {
        "title": "Nothing in this entry",
        "body": "Delete it, so no empty row is left in Purchases? If all you have is the receipt total, record it as a spending in “Money”",
        "finish": "Finish anyway",
        "spending": "Record as a spending in “Money”"
      },
      "removed": "Entry deleted: {name}",
      "removed_announced": "Entry deleted: {name}. Undo — 10 seconds",
      "restore": "Undo",
      "restored": "The entry is back",
      "not_restored": "The entry did not come back: {name}",
      "not_restored_open": "Another entry was started meanwhile, and only one can be open",
      "not_restored_gone": "More than ten minutes have passed — the entry is deleted for good",
      "not_restored_recorded": "This receipt was recorded again meanwhile, and one receipt is recorded only once"
    },
    "empty": {
      "title": "The entry has started",
      "body": "Add the first item — the rest can be filled in later"
    },
    "error": {
      "title": "The server did not answer",
      "body": "Your items are still on the phone, nothing is lost",
      "strip": "The server did not answer · your items are still on the phone"
    },
    "offline": {
      "strip": "Offline · items are kept on the phone and will be sent on their own"
    },
    "none": {
      "action": "Start the entry"
    },
    "home": {
      "pending": {
        "one_place": "From {place}, the latest {when}",
        "two_places": "From {a} and {b}",
        "more_places": "From {a}, {b} and other places"
      }
    },
    "quantity": "{amount} {unit}",
    "queued": {
      "waiting": "not sent yet",
      "editing": "edit not sent",
      "removing": "being removed",
      "unnamed": "Item"
    },
    "rejected": {
      "title": "One change was not accepted",
      "named": "«{name}» was not accepted",
      "unknown": "The server did not accept the change ({code})",
      "fix": "Correct it",
      "drop": "Dismiss",
      "orphaned": "it holds {n} purchase, and it is waiting | it holds {n} purchases, and they are waiting",
      "drop_trip": "Drop the entry and its purchases"
    },
    "rate_line": "rate {rate} · {date}",
    "rate_line_source": "rate {rate} · {date} · {source}",
    "rate_line_mine": "my rate {rate} · {date}",
    "flip": "Show in the other currency",
    "caveat": {
      "pending": "+ {n} item not sent yet | + {n} items not sent yet",
      "partial": "converted from {currency} only",
      "local": "the entry has not been sent — the total comes after it has"
    },
    "rate": {
      "source_cba": "the Central Bank of Armenia",
      "source_cbr": "the Bank of Russia",
      "source_erapi": "open.er-api.com",
      "fallback": "Not a rate of {bank} — it has been silent for over a week. Source:",
      "stale_official": "The rate is of {date} — {bank} has published nothing since",
      "stale_fallback": "The rate is of {date} — nothing newer has been published anywhere",
      "jump_title": "The rate jumped by more than a quarter",
      "jump_previous": "{rate} instead of {previous} of {date}",
      "jump_alone": "{rate}, and there is no earlier rate beside it",
      "choose": "Choose a rate",
      "sheet_title": "Which rate should count?",
      "sheet_meta": "Only the conversion changes — the prices stay as they were",
      "new": "The new one",
      "old": "The earlier one",
      "mine": "My own",
      "own": "enter",
      "save": "Count by it",
      "saving": "Saving…",
      "failed": "The choice could not be saved. Try again",
      "source_nbg": "the National Bank of Georgia",
      "source_nbs": "the National Bank of Serbia"
    },
    "start": {
      "title": "Where are you?",
      "other": "Another place"
    },
    "unsent": {
      "title": "{n} purchase has not been sent | {n} purchases have not been sent",
      "body": "They are on the phone. They go out when there is a connection and the app is open"
    },
    "elsewhere": {
      "title": "An entry in {place} is already open",
      "body": "Continue the open entry, or finish it and start a new one in {mine}? Purchases for the new entry are saved on this device and will wait for your choice.",
      "body_other": "Purchases for the new entry ({mine}) are saved on this device. Added to the open entry, they are recorded against {place} — prices of one shop must not be written down against another, they are what the comparison rests on.",
      "join": "Add them to that entry",
      "finish": "Finish that entry",
      "choose": "Choose the entry"
    },
    "history": {
      "title": "Purchases",
      "error_title": "Could not load purchases",
      "error_body": "Saved data is still on this device. Try again.",
      "offline_title": "Offline — saved purchases",
      "offline_body": "Only data saved on this device is available. The rest will load when connected.",
      "local_finish": "Finished on this device — not sent yet",
      "more": "Show more",
      "loading": "Loading…",
      "when": "{day}, {time}",
      "missing_title": "Purchases unavailable",
      "missing_body": "These purchases could not be found in your account. Return to Purchases.",
      "pending": "Changes are on this device. We will send them when connected.",
      "no_purchases": "No purchases here yet. Add anything you forgot.",
      "rejected_title": "A change was not accepted",
      "rejected_body": "Purchases remain on this device. Purchases shows the reason and lets you correct the purchase.",
      "review": "Review the refusal"
    },
    "manual_meta": "Recording by hand · {when}",
    "manual_since": "{day}, since {time}"
  },
  "purchases": {
    "title": "Purchases",
    "manual": "Record purchases",
    "open_manual_meta": "{count} · recording by hand",
    "continue": "Continue",
    "group_recorded": "Recorded",
    "recorded": "{count} · {day}",
    "empty": {
      "title": "Your purchases will be here",
      "body": "Record what you took and what it cost — the button below. Rate them at home, and «What to buy» will tell you what to take again."
    },
    "error": {
      "title": "Purchases did not load",
      "body": "You can still record new ones — the button below"
    },
    "manual_ask": {
      "title": "Already recording «{place}»",
      "body": "Only one entry can be open. Continue this one — or finish it and start a new one.",
      "continue": "Continue «{place}»",
      "finish": "Finish and start a new one"
    },
    "capture": "Photograph a receipt",
    "manual_by_hand": "Add by hand",
    "group_working": "Reading",
    "group_review": "Check and save",
    "receipt_from": "Receipt from {day}, {time}",
    "waiting": "{parts} · waiting for a connection",
    "sending": "{parts} · sending",
    "parsing_unknown": "reading · we’ll get the place from the receipt",
    "parsing_known": "{day}, {time} · reading lines…",
    "issues_check": "check {n} line | check {n} lines",
    "failed_meta": "couldn’t be read",
    "reshoot_meta": "no lines found — retake it",
    "no_items_meta": "no items · {day}",
    "recording_meta": "we’ll save it once you are online",
    "rejected_title": "Photo from {day}, {time}",
    "rejected_meta": "Not accepted: {reason}",
    "remove": "Remove",
    "reasons": {
      "not_photo": "no receipt in the photo",
      "too_large": "the photo is too large",
      "lost": "the photo wasn’t kept on this phone",
      "other": "the server didn’t take the receipt",
      "link": "the link did not fit"
    },
    "recorded_receipt": "{count} · {day} · from a receipt",
    "recorded_sum": "receipt total · {day}",
    "queued": {
      "waiting": "The photos are on your phone. We’ll send them once you are online — nothing to do.",
      "parsing": "Reading is under way — you can close the app. The ready receipt goes to “Check and save”.",
      "sending": "The photos are going to the server. If you close the app, sending goes on the next time you open it.",
      "stuck": "The server got only some parts of this receipt, and this phone has none of them. Delete the receipt and take it again.",
      "rejected": "The server didn’t take this receipt: {reason}. Remove it and take it again.",
      "link_waiting": "The link is on your phone. We will send it once there is a connection — nothing to do.",
      "link_sending": "The link is going to the server. If you close the app, sending carries on next time you open it.",
      "link_parsing": "Asking the Serbian tax office. A receipt just printed shows up there in a couple of minutes — you can close the app. Once ready, the receipt moves to «Check and save».",
      "link_rejected": "The server did not accept this receipt: {reason}. Remove it and shoot the QR code or paste the link again."
    },
    "delete": "Delete receipt",
    "delete_note": "The photo goes with it",
    "deleted": "Receipt deleted with its photo",
    "empty_capture": {
      "body": "Photograph a receipt — we read the lines, you check them and save with one button. No receipt — “Add by hand”."
    },
    "error_capture": "You can still photograph a receipt or add by hand",
    "stale": "Offline · purchases as of {when}",
    "stale_untimed": "Offline · purchases saved on this phone",
    "stale_error": "The server did not answer · purchases as of {when}",
    "stale_error_untimed": "The server did not answer · purchases saved on this phone",
    "earlier_online": "Earlier than {day} — once online",
    "offline": {
      "title": "Offline",
      "body": "We’ll show your purchases once you’re online. You can record new ones now — the button below"
    },
    "offline_capture": "We’ll show your purchases once you’re online. You can photograph a receipt or add by hand now",
    "receipts_error": {
      "title": "Receipts didn’t load",
      "body": "We’ll show them once the server answers"
    },
    "receipts_offline": "We’ll show your receipts once you’re online",
    "stuck_meta": "{parts} · not all parts arrived",
    "record_refused": "not saved — open it and fix it",
    "capture_link": "Receipt by link",
    "by_link": "by link",
    "asking_tax_office": "asking the tax office",
    "missing_meta": "the tax office did not show it",
    "invalid_meta": "the tax office does not accept it",
    "delete_note_link": "The receipt goes together with its link"
  },
  "item": {
    "search_title": "What did you pick up?",
    "search_placeholder": "Milk, matsun, cheese…",
    "search_hint": "Typos and Latin spelling are fine",
    "group_here_last": "Bought here last time",
    "group_recent": "You buy these often",
    "group_found": "Found",
    "group_similar": "Similar spelling",
    "results_announced": "Found {n} item | Found {n} items",
    "far_announced": "Nothing found for «{query}». {n} item with a similar spelling | Nothing found for «{query}». {n} items with a similar spelling",
    "quantity": "How much",
    "unit": "Unit",
    "unit_kg": "kg",
    "unit_g": "g",
    "unit_l": "l",
    "unit_ml": "ml",
    "unit_piece": "pc",
    "price": "Price as on the tag",
    "currency": "Price currency",
    "unit_price_label": "Per unit",
    "unit_price_pending": "Worked out for you — nothing to type",
    "unit_price_value": "{amount}/{unit}",
    "unit_price_announced": "Per unit: {value}",
    "cheaper": {
      "best": "Cheapest you paid: {place} — {price}, {day}",
      "best_here": "You paid {price} here — {day}",
      "there": "You paid {price} at {place} — {day}",
      "there_here": "It was {price} right here — {day}",
      "same": "Same as at {place} — {price}, {day}",
      "same_here": "Same as here on {day} — {price}",
      "cheaper": "Cheaper here — {place} was {price}, {day}",
      "cheaper_here": "Cheaper than here on {day} — it was {price}",
      "alternative": "{name} — {price} at {place}, {day} · rated {rating}"
    },
    "save": "Record",
    "save_edit": "Save",
    "delete": "Remove the item",
    "cancel": "Cancel",
    "offline_note": "Saved on the phone, sent once you are back online",
    "no_trip": {
      "body": "Start an entry first: a purchase needs a place",
      "action": "To Purchases"
    },
    "empty": {
      "title": "Nothing found for «{query}»",
      "text": "We’ll add it to the catalogue — type its name as the price tag has it",
      "action": "Suggest an item"
    },
    "not_listed": "Not here? Suggest an item",
    "propose": {
      "title": "New item",
      "name": "As the price tag says",
      "note": "What sets it apart on the shelf — optional",
      "submit": "Add to the catalogue",
      "offline": "Suggesting needs a connection",
      "needs_name": "Type the name",
      "needs_unit": "Choose a unit",
      "sending": "Adding…",
      "name_invalid": "The name holds a character the catalogue will not take — type the name again",
      "note_invalid": "The note holds a character the catalogue will not take — type the note again",
      "failed": "Could not add it. Please try again",
      "code": "Code {code} will be saved with the item",
      "hint_source": "Data from Open Food Facts ↗",
      "size": "{amount} {unit} in the pack",
      "size_drop": "Leave out how much is in the pack",
      "taken": "This code already belongs to «{name}»",
      "take": "Take «{name}»",
      "name_taken": "«{name}» is already there — name the item differently, with its brand for instance"
    },
    "error": {
      "title": "The server did not answer",
      "body": "The catalogue isn’t answering. Try again — or pick from your recent items",
      "body_alone": "The catalogue isn’t answering — try again in a moment",
      "fallback": "Pick from recent",
      "fallback_note": "For now — from your recent items"
    },
    "offline": {
      "body": "Searching your recent items only. The full catalogue is back once you are online",
      "strip": "Offline · searching your recent items only. The full catalogue comes back with a connection"
    },
    "barcode": {
      "scan": "Scan a barcode",
      "missing": "The catalogue does not know the code {code}",
      "missing_hint": "Or find it by name",
      "hint": "Looks like “{name}”",
      "hint_size": "Looks like “{name}”, {amount} {unit}",
      "hint_source": "according to Open Food Facts",
      "error_body": "Could not check the code {code}. Try again — or find the item by name",
      "offline_body": "None of your recent items has this code. Find the item by name — or scan it once you are online",
      "offline_strip": "Offline · searching your recent items only",
      "found": "Found by the code {code}",
      "found_announced": "Found by the code {code}: {name}",
      "pending": "Code {code} is waiting for its item — pick it in the list",
      "pending_drop": "Don't link the code",
      "bind_question": "Link code {code} to «{name}»?",
      "bind_hint": "Everyone who scans this code will see this item",
      "bind": "Link and record",
      "bind_busy": "Linking…",
      "without_code": "Record without the code",
      "propose_other": "It's a different item — suggest it",
      "taken": "Code {code} already belongs to «{name}»",
      "without_code_named": "Record «{name}» without the code",
      "bind_offline_strip": "Offline · the code is not linked. Try again with a connection — or record without the code",
      "bind_error_body": "Could not link code {code}. Try again — or record without the code",
      "not_this": "Code {code} — not this item?",
      "not_this_failed": "Could not unlink the code — check the connection",
      "in_store": "Code {code} is a shop's own label",
      "in_store_body": "The scales or the shop print it: another package gets another code. Find the item by its name",
      "detach_question": "Unlink code {code} from «{name}»?",
      "detach_hint": "Nobody will find it by this code any more",
      "detach": "Unlink",
      "detach_busy": "Unlinking…",
      "bind_named": "«{name}» is already in the catalogue. Link code {code} to it?"
    }
  },
  "sheet": {
    "close": "Close"
  },
  "advice": {
    "title": "What to buy",
    "own_data_only": "Your own ratings only, for now",
    "shared_data": "Average ratings from everyone who rated",
    "shared_note": "Reviews and prices are yours alone",
    "group_take": "Buy it",
    "group_if_cheap": "Only if it is cheap",
    "group_never": "Not worth buying anywhere",
    "badge_take": "BUY",
    "badge_if_cheap": "IF CHEAP",
    "badge_never": "DO NOT",
    "cheapest_at": "Cheapest at {place}",
    "bought_at": "Bought here: {place}",
    "also_at": "Also: {places}",
    "also_place": "{place} {price}",
    "threshold": "Worth buying below {price}",
    "price_at": "{price} · {place}",
    "no_price_shown": "The price is left out on purpose: there is nothing to compare",
    "rating": "{value} out of 5",
    "ratings_count": "{n} rating | {n} ratings",
    "rating_line": "{rating} · {count}",
    "truncated": "Showing {shown} of {total}",
    "stale": "Offline · the list as of {when}",
    "stale_error": "The server did not answer — the list as of {when}",
    "stale_loading": "Refreshing · the list as of {when}",
    "edit_action": "Change the rating",
    "edit": {
      "meta": "Only your own rating changes",
      "meta_new": "You have not rated this yet",
      "save_new": "Rate it",
      "keeps_score": "The rating stays as it was. To take it back, withdraw it",
      "withdraw": "Withdraw the rating",
      "withdrawing": "Withdrawing the rating…",
      "withdraw_hint": "The item leaves this screen, and the purchase goes back to «Ratings»",
      "withdraw_hint_shared": "Your rating leaves the average, and the purchase goes back to «Ratings»",
      "not_mine": "You have no rating here — refresh the list",
      "nothing_changed": "Nothing has changed",
      "failed": "Could not save it. Try again",
      "offline": "A rating can be changed once you are online"
    },
    "error": {
      "title": "The server did not answer",
      "body": "The list didn’t load. Try again",
      "body_capture": "The list didn’t load. You can still photograph a receipt"
    },
    "offline": {
      "title": "The list will show up once you are online",
      "body": "We’ll show the list as soon as you’re back online. You can record purchases now",
      "body_capture": "We’ll show the list as soon as you’re back online. You can photograph a receipt now"
    },
    "city_reloading": "Refreshing · the list for {city}",
    "stale_other_city": "Offline · the list for {oldCity} as of {when}. Prices for {city} will appear once you are back online",
    "cities_genitive": {
      "Гюмри": "Gyumri",
      "Ереван": "Yerevan",
      "Тбилиси": "Tbilisi",
      "Батуми": "Batumi",
      "Белград": "Belgrade",
      "Нови-Сад": "Novi Sad"
    },
    "search": {
      "label": "Search the catalogue",
      "placeholder": "Milk, lavash, cheese…",
      "group_unrated": "Not rated yet",
      "rate": "Rate",
      "empty": {
        "title": "No «{query}» found",
        "body": "The catalogue has no such item yet. Check the spelling — Latin letters and typos are fine",
        "body_offline": "Without a connection we search only what was rated. The whole catalogue — with a connection"
      },
      "error_body": "The search did not go through. Try again — or clear the field: the list is still there",
      "offline": "Offline · searching only the list as of {when}",
      "offline_more": "Unrated items and the whole catalogue — once there is a connection"
    },
    "home": {
      "new": {
        "title": "Record your first purchases",
        "body": "{app} will remember what you took and what it cost. And from your ratings it will tell you at the shelf what to take again and where it is cheaper."
      },
      "pending": {
        "title": "Now rate them",
        "body": "The purchases are recorded. Rate them at home — and this is where what to take again and where it is cheaper will show up."
      },
      "next": "What comes next",
      "step_purchases_title": "At the shop — «Purchases»",
      "step_purchases_body": "What you took and what it cost — the price per litre and kilo is ours to work out",
      "step_verdicts_title": "At home — «Ratings»",
      "step_verdicts_body": "Give each purchase 1 to 5",
      "step_advice_title": "Here — «What to buy»",
      "step_advice_body": "What to take again, only if cheap, never — and where it is cheaper",
      "trust": "Your own ratings and prices are free, other people’s come with access. There are no ads and no paid places here, and there never will be.",
      "new_capture": {
        "title": "Photograph your first receipt",
        "body": "{app} reads and translates it — you check and save. And from your ratings it tells you at the shelf what to buy again and where it’s cheaper."
      },
      "parsing": {
        "title": "Reading your first receipt",
        "body": "Reading is under way — you can close the app. The receipt will appear in Purchases: check and save it there."
      },
      "step_purchases_capture_title": "Check it in Purchases",
      "step_purchases_capture_body": "We read the receipt lines — you check them and save with one button",
      "manual_body": "No receipt — at the market, or if it got lost"
    }
  },
  "verdict": {
    "title": "Ratings",
    "pending_count": "{n} purchase is waiting to be rated | {n} purchases are waiting to be rated",
    "context": "{when} · {place}",
    "question_tail": "how was it?",
    "current": "Your rating: {n}",
    "scale_low": "Poor",
    "scale_high": "Great",
    "scale_label": "Rating {n} out of 5",
    "scale_group": "Rating",
    "review_label": "A couple of words — if you have any",
    "review_placeholder": "Smells of starch, not meat",
    "review_unsupported": "The review has a character that cannot be saved",
    "save": "Save the rating",
    "save_disabled": "Pick a rating",
    "skip": "Not now",
    "footnote": "Rating is separate from buying: the reminder comes the next day — nobody needs it at the till",
    "none": {
      "title": "Nothing to rate yet",
      "body": "Record a purchase first — we will ask here how it was",
      "action": "To purchases"
    },
    "empty": {
      "title": "Everything is rated",
      "body": "Thank you — the base is more accurate for it. We will remind you when a new purchase turns up",
      "action": "Open «What to buy»"
    },
    "error": {
      "title": "The rating did not go through",
      "body": "The draft is saved, we will try sending it again"
    },
    "offline": {
      "title": "The rating is saved",
      "body": "It will go on its own once you are back online. You can close the app",
      "strip": "Offline · your rating is saved on the phone and will go by itself"
    },
    "stale": "The list as of {when} — we will refresh it once you are back online",
    "stale_error": "The list as of {when} — the server did not answer",
    "load_error": {
      "title": "The list of purchases did not load",
      "body": "The server did not answer. Saved ratings are safe on the phone"
    },
    "load_offline": {
      "title": "The list of purchases will appear once you are online",
      "body": "Saved ratings are safe on the phone and will go on their own"
    },
    "returned": "The rating for «{name}» was not accepted — it comes back next",
    "sending": "Sending the rating…",
    "checking": "Checking what else is waiting to be rated…"
  },
  "money": {
    "approx": "≈ {amount}",
    "converted_package": "≈ {amount} per pack",
    "converted_note": "the conversion is approximate, we always compare by the price on the tag",
    "rate_official": "rate {rate} · CBA",
    "rate_frozen": "The rate is saved with the purchases. Last month does not change with today’s rate",
    "rate_label": "1 {currency} =",
    "source_mine": "mine",
    "source_official": "official",
    "home_currency": "My currency"
  },
  "spending": {
    "title": "Money",
    "subtitle": "Only you can see this",
    "month_prev": "Previous month",
    "month_next": "Next month",
    "year_prev": "Previous year",
    "year_next": "Next year",
    "spent": "Spent",
    "vs_previous": "{percent} vs {month}",
    "vs_same_day": "{change} vs the same day of {month}",
    "month_started": "The month has just started",
    "month_to": {
      "01": "January",
      "02": "February",
      "03": "March",
      "04": "April",
      "05": "May",
      "06": "June",
      "07": "July",
      "08": "August",
      "09": "September",
      "10": "October",
      "11": "November",
      "12": "December"
    },
    "month_of": {
      "01": "January",
      "02": "February",
      "03": "March",
      "04": "April",
      "05": "May",
      "06": "June",
      "07": "July",
      "08": "August",
      "09": "September",
      "10": "October",
      "11": "November",
      "12": "December"
    },
    "foreign_part": "Including {amount} (≈ {counted})",
    "uncounted": "Not counted: {amounts} — no rate for that day",
    "unsent": "Not counted yet: {n} spending is being sent | Not counted yet: {n} spendings are being sent",
    "income": "Came in",
    "income_uncounted": "and {amounts} not counted",
    "income_shifted_in": "with the salary of {days}",
    "income_shifted_out": "the salary of {days} counts next month",
    "rest_spendable": "without savings ≈ {amount}",
    "rest_uncounted": "not counted: {accounts}",
    "rest_operations": "{n} operation not counted | {n} operations not counted",
    "rest_from": "Accounts start on {day}",
    "rest_add": "Add an account",
    "rest_removed": "Accounts removed — bring back",
    "rate_live_mine": "At my rate of {rate} today",
    "rate_live_official": "At the {bank} rate of {rate} today",
    "rate_live_fallback": "At {rate} today — not a rate of the {bank}: it has been silent for over a week",
    "rate_frozen": "At the rate of {date}: {rate}. Past months are not recounted",
    "rate_none": "No rate to convert by yet",
    "rate_value": "{amount} per 1 {sign}",
    "categories_title": "Where it went",
    "summary": {
      "charts": "Charts",
      "accounts_now": "In accounts now",
      "accounts_spendable": "free to spend ≈ {amount}",
      "accounts_count": "{n} account | {n} accounts",
      "accounts_now_label": "Accounts: in accounts now ≈ {amount}, free to spend ≈ {spendable}",
      "accounts_then": "In accounts as of {when}",
      "accounts_then_label": "Accounts: in accounts as of {when} ≈ {amount}, free to spend ≈ {spendable}",
      "donut_more": "{n} more slice in Charts | {n} more slices in Charts",
      "donut_label": "Where it went: {list}. Open charts",
      "donut_later": "Shares appear once the month is refreshed",
      "donut_uncounted": "Shares appear once the spending has a rate",
      "donut_empty": "No spendings in {month} yet",
      "donut_empty_body": "Shares appear with the first spending. The year is in Charts",
      "donut_pending": "The first spending of {month} is on its way",
      "donut_pending_body": "Shares appear once it arrives. The year is in Charts",
      "donut_empty_label": "Where it went: no spendings in {month} yet. Open charts",
      "add": "Add spending",
      "offline_strip": "Offline · figures as of {when}. New spendings are kept on the phone",
      "refused": "{n} spending not accepted | {n} spendings not accepted",
      "refused_body": "The server did not accept it — fix or remove it in Spendings",
      "refused_open": "Open Spendings"
    },
    "charts": {
      "title": "Charts",
      "spent_title": "Spending by month",
      "spent_hint": "Tap a bar or slide a finger along the chart. Each month at that month's rate",
      "bar_label": "{month}, {amount}",
      "income_title": "In and out",
      "spent_legend": "Out",
      "difference": "Difference · {month}",
      "pair_label": "{month}: in {income}, out {spent}",
      "income_only": "All in {currency}, the income currency",
      "currency_in": {
        "AMD": "drams",
        "RUB": "roubles",
        "USD": "dollars",
        "EUR": "euros",
        "GEL": "lari",
        "RSD": "dinars"
      },
      "no_rate": "no rate for the month",
      "difference_uncounted": "not all counted",
      "income_uncounted": "In, not counted: {amounts}",
      "spent_uncounted": "Out, not counted: {amounts}",
      "uncounted": "not counted: {amounts}",
      "category_average": "{amount} on average",
      "category_missing": "That category is not on the charts — showing «{name}»",
      "empty": {
        "title": "Charts appear with your first spending",
        "body": "At least one month of spending or income is needed. Purchases from a shop come here by themselves"
      },
      "load_error": {
        "title": "Couldn't load the charts",
        "body": "The server didn't answer. Your spending and income are safe — try again"
      },
      "error_strip": "The server did not answer — charts as of {when}",
      "offline": {
        "strip": "Offline · charts as of {when}",
        "body": "Charts appear when the internet is back"
      },
      "rest": "Others",
      "mode": "Period",
      "mode_month": "Month",
      "mode_year": "Year",
      "year_center": "{year} · {n} month | {year} · {n} months",
      "year_rate_note": "Each month at that month's rate",
      "year_no_rate_one": "no rate for {month}",
      "year_no_rate_many": "no rate for {n} month | no rate for {n} months",
      "year_change": "{change} against the average",
      "year_change_running": "{change} against the usual by {day}",
      "year_avg": "{amount} on average, {from} to {to}",
      "year_avg_running": "{amount} on average, {from} to {to}, without the running month",
      "year_avg_few": "The average comes after {month}: three closed months are needed",
      "year_avg_short": "Too few closed months for an average: {n} of 3",
      "year_avg_uncounted": "No average: every closed month has spending with no rate",
      "year_avg_beyond": "No average: the months add up to more than can be counted",
      "year_flow_note": "Difference for {year} {amount}. All in {currency}, the income currency",
      "year_flow_missing": "The difference for {year} can't be counted: not everything converted — {months}. All in {currency}, the income currency",
      "category_months_title": "Category by month",
      "category_avg": "Dashed line: the average of closed months",
      "center_running": "{month} · ongoing",
      "center_share": "{share} · ≈ {amount}",
      "rest_names": "Others: {names}",
      "donut_order": "Slices go clockwise from the top, in the order of the list",
      "vs_usual_title": "Against the usual",
      "vs_usual_note": "{month} against the average of {from} — {to}. Ordered by the difference in {sign}",
      "vs_usual_note_running": "{month} so far against the average of {from} — {to}. Ordered by the difference in {sign}",
      "vs_usual_meta": "{amount} · usually {average}",
      "vs_usual_new": "new",
      "vs_usual_legend": "The mark is the category’s usual month",
      "vs_usual_spoken": "{name}: {amount}, usually {average}, {change}",
      "few_title": "The comparison starts with {month}",
      "few_body_none": "A usual month is the average of the closed months before the one shown, from three to twelve. None is closed before {month}.",
      "few_body_one": "A usual month is the average of the closed months before the one shown, from three to twelve. Only {closed} is closed before {month}.",
      "few_body_many": "A usual month is the average of the closed months before the one shown, from three to twelve. Only {closed} are closed before {month}.",
      "pace_title": "Month pace",
      "pace_usual": "Usual",
      "pace_day": "By {date}",
      "pace_today": "By {date} · today",
      "pace_sub": "usually by this day {amount} · {change}",
      "pace_sub_plain": "usually by this day {amount}",
      "pace_note": "Running total by day. Dashed is the usual month: the average of closed months.",
      "pace_move": "Move the slider to see a day",
      "pace_few": "The usual month’s dashed line starts with {month}.",
      "pace_spoken": "{date}: {amount}, usually {average}",
      "pace_spoken_few": "{date}: {amount}",
      "few_title_none": "No comparison for this month",
      "pace_few_none": "There is no usual month for this one.",
      "pace_uncounted": "No dashed line: every closed month has spending with no rate."
    },
    "share_tiny": "<1 %",
    "categories_link": "Categories",
    "day_today": "Today · {date}",
    "day_yesterday": "Yesterday · {date}",
    "row_open": "Open spending:",
    "row_open_trip": "Open purchases:",
    "trip_row_title": "Purchases at “{place}”",
    "trip_row_meta": "{category} · {n} item | {category} · {n} items",
    "trip_row_sum": "{category} · receipt total",
    "uncounted_row": "not counted",
    "more": "And {n} more spending over {range} | And {n} more spendings over {range}",
    "more_retry": "Load the rest",
    "month_empty": "Nothing spent this month",
    "pending": "Sending…",
    "editing": "Change being sent",
    "refused": "Not accepted",
    "removed": "Deleted: {title} · {amount}",
    "removed_announced": "Deleted: {title} · {amount}. Undo — 10 seconds",
    "restore": "Undo",
    "restored": "Spending restored",
    "saved_offline": "Spending saved on the phone, we will send it later",
    "empty": {
      "title": "Add your first spending",
      "body": "Barber, rent, café, taxi — anything that is not a shop. Recorded purchases land here by themselves"
    },
    "load_error": {
      "title": "Could not load spending",
      "body": "The server did not answer. Saved spending is not lost — try again"
    },
    "offline": {
      "title": "No connection",
      "body": "Spending will appear when the internet is back. You can record a new one now",
      "body_read": "Spending will appear when the internet is back"
    },
    "error_strip": "The server did not answer — spending as of {when}",
    "rejected_other": {
      "title": "The server did not accept an action",
      "unknown": "The server answered: {code}"
    },
    "category": {
      "groceries": "Groceries",
      "cafe": "Cafés and restaurants",
      "rent": "Rent",
      "home": "Home",
      "beauty": "Beauty and hygiene",
      "transport": "Transport",
      "telecom": "Phone and internet",
      "health": "Health",
      "clothes": "Clothes",
      "pets": "Pets",
      "leisure": "Leisure",
      "documents": "Documents",
      "other": "Other"
    },
    "icon": {
      "tag": "Tag",
      "gift": "Gift",
      "sport": "Sport",
      "study": "Study",
      "kids": "Kids",
      "taxi": "Taxi",
      "car": "Car",
      "fuel": "Fuel",
      "travel": "Travel",
      "coffee": "Coffee",
      "bar": "Bar",
      "games": "Games",
      "books": "Books",
      "music": "Music",
      "phone": "Phone",
      "tech": "Tech",
      "repair": "Repairs",
      "flowers": "Flowers",
      "charity": "Charity",
      "subscriptions": "Subscriptions",
      "bank": "Bank and taxes",
      "languages": "Languages",
      "dentist": "Dentist",
      "utilities": "Utilities"
    },
    "currency_name": {
      "AMD": "Drams",
      "RUB": "Roubles",
      "USD": "Dollars",
      "EUR": "Euros",
      "GEL": "Lari",
      "RSD": "Dinars"
    },
    "sheet": {
      "title_add": "New spending",
      "title_edit": "Spending",
      "meta_edit": "Added by hand · {date}",
      "amount": "Amount",
      "amount_placeholder": "0",
      "currency": "Currency of the spending",
      "conversion_mine": "≈ {amount} at my rate of {rate}",
      "conversion_official": "≈ {amount} at the {bank} rate of {rate}",
      "conversion_fallback": "≈ {amount} at {rate}, not a rate of the {bank}",
      "conversion_later": "Counted at the rate of the day",
      "conversion_counted": "≈ {amount} at the rate of the day",
      "category": "Category",
      "add_category": "Own",
      "more": "More…",
      "more_title": "Category",
      "date": "When",
      "date_today": "Today, {date}",
      "date_yesterday": "Yesterday, {date}",
      "note": "What it is",
      "note_placeholder": "Barber, domain, taxi",
      "place": "Where",
      "place_placeholder": "Café, service, website",
      "optional": "· optional",
      "details_title": "Date, note, place",
      "details_none": "no note",
      "details_label": "Date, note, place: {value}",
      "details_done": "Done",
      "shop_title": "A purchase in a shop?",
      "shop_body": "Record it in Purchases — the item goes into the catalogue and ratings, and the spending lands here by itself",
      "shop_action": "Purchases ›",
      "bad_amount": "Enter an amount above zero",
      "bad_category": "Choose a category",
      "bad_day": "Choose a day no later than today",
      "bad_text": "This has characters that cannot be saved",
      "offline": "No connection. We will keep it on the phone and send it when the internet is back",
      "save": "Save the spending",
      "refused": "The server did not accept the spending: {reason}. Fix it and save again",
      "refused_conflict": "The spending was changed on another device. This is what you entered — save again over it",
      "dismiss": "Discard",
      "remove": "Delete the spending",
      "trip_meta": "{date} · {n} item | {date} · {n} items",
      "trip_note": "This spending came from Purchases and is changed there — with the prices and ratings of the items",
      "trip_open": "Open in Purchases",
      "trip_items_offline": "The items will appear when the connection is back",
      "trip_items_error": "Could not load the items"
    },
    "categories": {
      "title": "Categories",
      "presets": "Ready-made",
      "own_group": "Your own",
      "archived": "Taken out",
      "remove": "Take out",
      "remove_label": "Take out the category “{name}”",
      "restore_label": "Bring back the category “{name}”",
      "add": "Add a category",
      "note": "A category taken out leaves the choice but stays with its spending and in past months",
      "load_error": {
        "title": "Could not load the categories",
        "body": "The server did not answer. Try again"
      },
      "offline": {
        "title": "No connection",
        "body": "Categories will appear when the internet is back"
      }
    },
    "new_category": {
      "title": "New category",
      "name": "Name",
      "placeholder": "Taxi, sport, gifts",
      "save": "Add",
      "bad_empty": "Enter a name",
      "bad_taken": "This category already exists",
      "edit_title": "Category",
      "icon": "Icon",
      "colour": "Colour",
      "colour_label": "Colour {n} of {total}",
      "edit_save": "Save",
      "remove": "Take out the category"
    },
    "entries_label": "Money sections",
    "month_in": {
      "01": "January",
      "02": "February",
      "03": "March",
      "04": "April",
      "05": "May",
      "06": "June",
      "07": "July",
      "08": "August",
      "09": "September",
      "10": "October",
      "11": "November",
      "12": "December"
    },
    "rest_on": "On accounts {date}",
    "list": {
      "title": "Spendings",
      "refused": "Not accepted",
      "refused_more": "And {n} more, marked in the journal below | And {n} more, marked in the journal below",
      "refused_below": "{n} marked in the journal below — show | {n} marked in the journal below — show",
      "count": "{n} spending | {n} spendings",
      "unsent": "{n} spending not counted yet | {n} spendings not counted yet",
      "offline_strip": "Offline · spendings as of {when}. New ones are kept on the phone",
      "empty": {
        "title": "No spendings in {month}",
        "body": "Add a spending or record purchases in Purchases — they will show up here by themselves"
      }
    },
    "entry_value": "{name}, {value}"
  },
  "exchange": {
    "title": "Money exchange",
    "my_rate": "My rate",
    "basis_weighted": "average of what is left · since {date}",
    "basis_last": "by the last exchange · since {date}",
    "basis_income": "by the last income · since {date}",
    "estimated": "part of it at the {bank} rate of the days of exchanges and incomes: what that money cost was never recorded",
    "base_since": "Counting in {base} since {date} — earlier exchanges in another currency are not in the rate and stay as they were",
    "cost_line": "{rate} · {basis}",
    "cost_line_estimated": "{rate} · {basis} · part at the {bank} rate",
    "no_wallet": "No {quote} has come in yet, by exchange or income — new purchases count by the {bank} rate",
    "wallet_out_of_band": "Your exchanges put the rate of {quote} per {base} beyond what an entry can keep — check their amounts. New purchases count by the {bank} rate",
    "wallet_unknown": "Rate unknown: the {given} → {quote} exchange of {date} has nothing to be valued by — there is no recent {dayBank} rate for that day. New purchases count by the {bank} rate until you record an exchange of a known price or an income on a day with a fresh {bank} rate",
    "wallet_old_reckoning": "Rate unknown: the {quote} bought on {date} with {given} have no price in {base} — after a change of the currency of conversion the old reckoning is not re-counted. New purchases count by the {bank} rate until you record an exchange paid in {base} or an income in {quote} after the change, on a day with a fresh {bank} rate",
    "wallet_unknown_income": "Rate unknown: the {quote} income of {date} has nothing to be valued by — there is no recent {bank} rate for that day. New purchases count by the {bank} rate until you record an exchange of a known price or an income on a day with a fresh {bank} rate",
    "wallet_old_reckoning_income": "Rate unknown: the {quote} received on {date} have no price in {base} — after a change of the currency of conversion the old reckoning is not re-counted. New purchases count by the {bank} rate until you record an exchange paid in {base} or an income in {quote} after the change, on a day with a fresh {bank} rate",
    "preference_legend": "New purchases count",
    "preference_personal": "by my rate",
    "preference_official": "by the {bank} rate",
    "preference_hint": "My rate comes from exchanges and incomes; until there is one, purchases take the {bank} rate anyway",
    "record": "Record an exchange",
    "record_offline": "Recording an exchange needs a connection",
    "error_strip": "The server did not answer — exchanges as of {when}",
    "list_title": "Exchanges",
    "row_amounts": "{given} → {received}",
    "row_rate": "{date} · {rate}",
    "amended": "amended {date}",
    "amend_conflict": "This exchange was already amended on another device — here it is as it stands now. Amend it again if you need to",
    "amend_conflict_stale": "This exchange was already amended on another device. It will show as it stands now once the server can be reached",
    "vanished": "This exchange is gone — it was removed. The list is up to date",
    "vanished_stale": "This exchange is gone — it was removed. The list will be updated once the server can be reached",
    "remove_sheet": {
      "title": "Delete the exchange?",
      "body": "A deleted exchange no longer counts in the rate of new purchases. Past purchases do not change",
      "confirm": "Delete",
      "confirm_busy": "Deleting…"
    },
    "removed": "Exchange deleted: {amounts}",
    "removed_announced": "Exchange deleted: {amounts}. Bring back — 10 seconds",
    "restore": "Bring back",
    "restoring": "Bringing back…",
    "restore_offline": "Will bring back once online",
    "restored": "The exchange is back",
    "restore_gone": "The exchange can no longer be brought back — the removal is final. If it was needed, record it again",
    "conflict": "This exchange is already recorded — the list shows it as it stands now. If the amounts are wrong, tap it in the list and amend it",
    "conflict_stale": "This exchange is already recorded — do not record it again. It will show once the server can be reached",
    "empty": {
      "title": "No exchanges yet",
      "body": "Record what you gave and what you got — the rate is worked out for you. Until you have a rate of your own, purchases count by the {bank} rate"
    },
    "offline": {
      "title": "No connection",
      "body": "The exchanges will be shown when the connection is back",
      "strip": "Offline · exchanges as of {when}. Recording an exchange and changing the rate need a connection",
      "strip_record": "Offline · exchanges as of {when}. Recording an exchange needs a connection"
    },
    "load_error": {
      "title": "Could not load the exchanges",
      "body": "The server did not answer properly. Try again"
    },
    "failed": "That did not work. Check the connection and try again",
    "sheet": {
      "title": "Exchange",
      "title_amend": "Amend the exchange",
      "meta": "What you gave and what you got — the rate is worked out for you",
      "given": "Gave",
      "received": "Got",
      "currency": "Currency",
      "same_currency": "The same currency on both sides is not an exchange",
      "day": "Day of the exchange",
      "held": "{currency} held before the exchange",
      "held_hint": "Optional. With it the rate accounts for what the money left over cost; without it the rate of this exchange is taken",
      "held_estimate": "By the recorded spending ≈ {amount}",
      "held_estimate_last": "Of the last exchange ≈ {amount} is left by the recorded spending",
      "held_estimate_last_income": "Of the last income ≈ {amount} is left by the recorded spending",
      "note": "Where, and a note",
      "note_placeholder": "Say, «VTB cash machine» or «from memory»",
      "bad_note": "There is nothing here to keep — write at least a word or leave the field empty",
      "history": "Earlier versions",
      "version": "until {until}: {amounts} · {date}",
      "version_note": "until {until}: {amounts} · {date} · {note}",
      "save": "Save the exchange",
      "save_amend": "Save the amendment",
      "save_offline": "Will save once online",
      "remove": "Delete the exchange",
      "remove_offline": "Will delete once online",
      "offline": "Offline · amending and deleting the exchange need a connection — what you typed stays here",
      "offline_amend": "Offline · amending the exchange needs a connection — what you typed stays here",
      "unanswered": "The server did not answer",
      "amend_conflict": "While you were amending it, this exchange was amended on another device. It now stands as below; save again to write your amounts over it",
      "amend_conflict_stale": "While you were amending it, this exchange was amended on another device. It will show as it stands now once the server can be reached",
      "current": "Now recorded: {details}",
      "current_held": "held before {amount}",
      "saving": "Saving the exchange…",
      "bad_day": "Choose the day of the exchange",
      "channel": "How it was changed",
      "channel_none": "Not said",
      "channel_bankCash": "Bank, cash",
      "channel_bankNoncash": "Non-cash",
      "channel_exchanger": "Exchange office"
    },
    "edit_on": "Amend the exchange of {date}:",
    "card_given": "Gave",
    "card_received": "Got",
    "card_rate": "Exchange rate",
    "card_official": "{source} on {date}",
    "card_source_cba": "Central Bank of Armenia",
    "card_source_cbr": "Bank of Russia",
    "card_source_erapi": "open.er-api.com",
    "card_source_nbg": "National Bank of Georgia",
    "card_source_nbs": "National Bank of Serbia",
    "card_more": "{amount} more than the central bank",
    "card_less": "{amount} less than the central bank",
    "card_equal": "Exactly the central bank rate",
    "card_more_other": "{amount} more than the {source} rate",
    "card_less_other": "{amount} less than the {source} rate",
    "card_equal_other": "Exactly the {source} rate",
    "card_no_official": "No {bank} rate for this day — nothing to compare with",
    "card_no_official_short": "No {bank} rate for this day",
    "card_doubtful": "The {bank} rate of that day is in doubt — no comparison",
    "channel": {
      "bankCash": "Banks, cash",
      "bankNoncash": "Banks, non-cash",
      "banksAll": "Banks, all clients",
      "exchanger": "Exchange offices"
    },
    "market": {
      "title": "Rates from the Central Bank of Armenia",
      "hint": "Average rates of the day's deals of banks and exchange offices with people. The best for you is starred",
      "official": "Central bank on {date}: {rate}",
      "sell": "Sell",
      "buy": "Buy",
      "where": "Where to change",
      "best_mark": "best",
      "row_date": "on {date}",
      "best": "Best rate on {date}: {channel}",
      "own": "{channel} on {date}",
      "worse": "{amount} · worse than {where}",
      "better": "{amount} · better than {where}",
      "equal": "Exactly as {where}",
      "where_bankCash": "at banks for cash",
      "where_bankNoncash": "at banks non-cash",
      "where_banksAll": "at banks (all clients)",
      "where_exchanger": "at exchange offices",
      "pending": "The central bank publishes exchange offices of this day later — the line will update itself"
    },
    "vs_market": {
      "title": "Exchanges against the market",
      "note": "Over 12 months, each exchange against the market of its day by the Central Bank of Armenia: its own channel when named, else the best rate. Minus — you gave more than the market",
      "uncounted": "Not compared: {n} exchange — no market or rate for that day | Not compared: {n} exchanges — no market or rate for those days",
      "count": "{n} exchange | {n} exchanges",
      "no_place": "No place",
      "worse": "worse than the market",
      "better": "better than the market",
      "count_word": "{count} · {word}"
    },
    "rate_chart": {
      "title": {
        "RUB": "Rouble rate over {period}",
        "USD": "Dollar rate over {period}",
        "EUR": "Euro rate over {period}"
      },
      "period": "Period",
      "period_option": {
        "1": "Month",
        "6": "6 months",
        "12": "12 months"
      },
      "period_in": {
        "1": "the last month",
        "6": "the last 6 months",
        "12": "the last 12 months"
      },
      "legend_market": "Market · all bank clients",
      "legend_mine": "My exchanges",
      "pair": "Pair",
      "pair_option": "{currency} and {dram}",
      "week": "Week to {day} · market",
      "day": "{day} · market",
      "no_market": "No market that week",
      "no_market_day": "No market that day",
      "no_market_period": "No market in {period}",
      "mine": "My exchange {day} · {rate}",
      "diff": "{change} · {word}",
      "spoken_diff": "{change}, {word}",
      "mine_no_market": "No market that day",
      "mine_no_rate": "Not compared: no central bank rate that day",
      "no_change": "not compared",
      "none": "No exchanges that week",
      "none_day": "No exchanges that day",
      "none_period": "No exchanges in {period}",
      "spoken_market": "market {rate}",
      "spoken_no_market": "no market",
      "spoken": "Week to {day}: {market}",
      "spoken_day": "{day}: {market}",
      "spoken_mine": "Week to {day}: {market}; my exchange {date}: {mine}, {change}",
      "spoken_mine_day": "{day}: {market}; my exchange: {mine}, {change}",
      "note_week_bankBuys": "The line is the market: what banks paid all clients for the currency at the end of each week, by the Central Bank of Armenia. Dots are your exchanges: above the line — you got more drams. The mark leads to the market the exchange was compared with: your way of exchanging, or the best that day. Tap the chart to see a week",
      "note_day_bankBuys": "The line is the market: what banks paid all clients for the currency that day, by the Central Bank of Armenia; at weekends, Friday's. Dots are your exchanges: above the line — you got more drams. The mark leads to the market the exchange was compared with: your way of exchanging, or the best that day. Tap the chart to see a day",
      "note_week_bankSells": "The line is the market: what banks charged all clients for the currency at the end of each week, by the Central Bank of Armenia. Dots are your exchanges: below the line — you gave fewer drams. The mark leads to the market the exchange was compared with: your way of exchanging, or the best that day. Tap the chart to see a week",
      "note_day_bankSells": "The line is the market: what banks charged all clients for the currency that day, by the Central Bank of Armenia; at weekends, Friday's. Dots are your exchanges: below the line — you gave fewer drams. The mark leads to the market the exchange was compared with: your way of exchanging, or the best that day. Tap the chart to see a day"
    }
  },
  "income": {
    "title": "Income",
    "record": "Record income",
    "record_offline": "Recording income needs a connection",
    "error_strip": "The server did not answer — income as of {when}",
    "row_line": "{source} · {date}",
    "amended": "amended {date}",
    "remove_sheet": {
      "title": "Remove this income?",
      "body": "Past purchases do not change. If this income was part of your rate, new purchases will be counted without it",
      "confirm": "Remove income",
      "confirm_busy": "Removing income…"
    },
    "removed": "Income removed: {amount}",
    "removed_announced": "Income removed: {amount}. Bring back — 10 seconds",
    "restore": "Bring back",
    "restoring": "Bringing back…",
    "restore_offline": "Will bring back once online",
    "restored": "Income restored",
    "restore_gone": "This income can no longer be restored — the removal is final. If you needed it, record it again",
    "conflict": "This income is already recorded — here it is as it stands. If something is wrong, tap it in the list and amend it",
    "conflict_stale": "This income is already recorded — do not record it again. It will show once the server can be reached",
    "amend_conflict": "This income was amended on another device — here it is as it stands now. Amend it again if you need to",
    "amend_conflict_stale": "This income was amended on another device. It will show as it stands now once the server can be reached",
    "vanished": "This income is gone — it was removed. The list is up to date",
    "vanished_stale": "This income is gone — it was removed. The list will be updated once the server can be reached",
    "empty": {
      "title": "No income yet",
      "body": "Record how much came in and when — we will add up each month. Income is optional: purchases and ratings work without it"
    },
    "offline": {
      "title": "No connection",
      "body": "We will show your income once the connection is back",
      "strip": "Offline · income as of {when}"
    },
    "load_error": {
      "title": "Could not load your income",
      "body": "The server did not answer properly. Try again"
    },
    "failed": "That did not work. Check the connection and try again",
    "source": {
      "salary": "Salary",
      "bonus": "Bonus",
      "freelance": "Freelance / side job",
      "debt_return": "Debt repaid",
      "sale": "Sold something",
      "gift": "Gift / help",
      "interest": "Deposit interest",
      "brought": "Money brought along",
      "other": "Other"
    },
    "sheet": {
      "title": "Income",
      "title_amend": "Amend income",
      "meta": "How much came in and when — in any of the four currencies",
      "amount": "Amount",
      "currency": "Currency",
      "bought_hint": "Bought this money with {base}? Record it as an exchange — the rate will count your price",
      "source": "From",
      "source_placeholder": "Choose",
      "no_source": "Choose where the money came from",
      "day": "Day received",
      "bad_day": "Choose the day it came in",
      "held": "{currency} held before it came in",
      "held_hint": "Optional. With it the rate counts what the money already held cost; without it we take the {bank} rate of that day",
      "note": "Note",
      "note_placeholder": "For example, «for September»",
      "bad_note": "There is nothing to save in the note — write a word or leave it empty",
      "history": "Earlier versions",
      "version": "until {until}: {amount} · {source} · {date}",
      "version_note": "until {until}: {amount} · {source} · {date} · {note}",
      "save": "Save income",
      "save_amend": "Save the amendment",
      "save_offline": "Will save once online",
      "remove": "Remove the income",
      "remove_offline": "Will remove once online",
      "offline": "Offline · amending and removing the income need a connection — what you typed stays here",
      "offline_amend": "Offline · amending the income needs a connection — what you typed stays here",
      "unanswered": "The server did not answer",
      "saving": "Saving income…",
      "amend_conflict": "While you were editing, this income was amended on another device. It now stands as below; save again to write yours over it",
      "amend_conflict_stale": "While you were editing, this income was amended on another device. It will show as it stands now once the server can be reached",
      "current": "Now recorded: {details}",
      "current_held": "held before {amount}"
    },
    "fab": "Income",
    "edit_on": "Amend income of {date}:"
  },
  "devices": {
    "title": "Devices",
    "list_title": "Where you are signed in",
    "this_device": "This device",
    "unknown": "Unknown device",
    "meta_current": "Signed in {signedIn}",
    "meta": "Signed in {signedIn} · last seen {seen}",
    "end": "End",
    "end_label": "End the session on {device}",
    "end_label_unknown": "End the session on an unknown device",
    "end_sheet": {
      "title": "End the session on {device}?",
      "title_unknown": "End the session on an unknown device?",
      "body": "Molvia will ask to sign in with Telegram again on that device. This cannot be undone from here.",
      "confirm": "End session",
      "confirm_busy": "Ending…"
    },
    "end_failed": "Could not end that session. Check the connection and try again.",
    "ended": "The session on {device} has ended",
    "ended_unknown": "The session on an unknown device has ended",
    "more": "Showing the latest {shown} of {total}",
    "note": "A device whose session was ended asks to sign in again the next time it is opened. What is saved on the device itself is beyond the server's reach.",
    "load_error": {
      "title": "The list did not load",
      "body": "The server did not answer. Try again."
    },
    "offline": {
      "title": "No connection",
      "body": "The list of devices will be here when the connection is back."
    }
  },
  "bot": {
    "title": "Telegram bot",
    "group_messages": "Messages",
    "blocked": "The bot is blocked in Telegram, so no messages arrive. Unblock the bot and they come back.",
    "reminders": {
      "label": "Remind me to rate",
      "hint": "The evening after a purchase the bot asks how it was. Leave it unanswered and it asks less often, then keeps quiet for half a year."
    },
    "receipts": {
      "label": "Tell me when a receipt is read",
      "hint": "If you left the screen while it was being read. The message names the shop or the receipt’s date and the number of items — no sums, no products."
    },
    "load_error": {
      "title": "The bot settings did not load",
      "body": "The server did not answer. Try again."
    },
    "offline": {
      "title": "No connection",
      "body": "The bot settings will be here when the connection is back."
    }
  },
  "sign_out": {
    "title": "Sign out of Molvia on this device?",
    "body": "Everything Molvia saved on this device will be erased. Nothing is lost on the server: sign in with Telegram and it all comes back.",
    "unsent": "{n} entry has not been sent or was not accepted and will be lost | {n} entries have not been sent or were not accepted and will be lost",
    "confirm": "Sign out and erase",
    "confirm_busy": "Signing out…",
    "offline": "Signing out needs a connection: without one the session on the server cannot be ended.",
    "error": "Could not sign out: the server did not answer. Try again."
  },
  "erase": {
    "title": "Delete all your data?",
    "goes": "Everything Molvia knows about you goes: purchases, spendings and their categories, currency exchanges, incomes, accounts and checks, ratings and reviews, search picks, visit marks, settings and sign-ins on every device.",
    "stays": "The items, shops and barcodes you added to the shared catalogue, and the shops’ memory — which item stands behind a receipt line and the shelf price — stay, without your name. One number stays too: how many people who came in the same week deleted their data.",
    "devices": "What is saved on this device is erased. Copies on other devices stay until the app or the site data is deleted there.",
    "final": "This cannot be undone. You can download a copy first: «Download my data».",
    "confirm": "Delete for good",
    "confirm_busy": "Deleting…",
    "offline": "Deleting needs a connection.",
    "error": "Could not delete: the server did not answer. Try again.",
    "signed_out": "This sign-in has already ended, and this tap deleted nothing. If you have already deleted your data — here, in the bot or on another device — it is gone; if not, sign in and delete it again.",
    "unknown": "We do not know whether the data was deleted: the answer to the last tap was lost, and the sign-in is gone."
  },
  "identity": {
    "error": {
      "title": "Could not check the sign-in",
      "body": "The app is open, but nothing is sent until the server answers."
    },
    "offline": {
      "title": "Working without a connection",
      "body": "Purchases are kept on the phone and sent once the internet is back."
    }
  },
  "login": {
    "title": "Sign in",
    "promise": "What to buy in a new place — and where",
    "offer": {
      "title": "Sign in with your Telegram",
      "body": "Your purchases and ratings then survive a change of phone. We store neither your name nor your phone number."
    },
    "start": "Sign in with Telegram",
    "starting": "Opening Telegram…",
    "waiting": {
      "title": "Open Telegram and tap «Sign in»",
      "body": "The link lives five minutes. Come back here — the app will recognise you by itself."
    },
    "open": "Open Telegram",
    "restart": "Start again",
    "welcome": {
      "title": "Signed in. Is this your account?",
      "body": "Everything you write from here lands in it.",
      "created": "Account created: {day}"
    },
    "confirm": "Yes, that is me",
    "refuse": "That is not me",
    "unavailable": {
      "title": "This link no longer works",
      "body": "Five minutes may have passed, or the login has been collected. Start again."
    },
    "rate_limited": {
      "title": "Too many sign-in attempts",
      "body": "That is everybody's requests together. Try in a minute."
    },
    "disabled": {
      "title": "Signing in with Telegram is not set up",
      "body": "This copy has no bot. That happens in development only."
    },
    "error": {
      "title": "Could not sign in",
      "body": "Something got in the way. Try again."
    },
    "offline": {
      "title": "No internet, no sign-in",
      "body": "We will try by ourselves once the connection is back."
    },
    "erased": "Your data has been deleted. You can sign in again, and it will be a new, empty account.",
    "erase_unknown": "We do not know whether your data was deleted: the server's answer was lost. Sign in: if the account is empty, it was deleted; if not, delete it again.",
    "erase_kept": "The sign-in on this device had already ended, and this tap deleted nothing. Sign in: if the account is empty, the data is already deleted; if not, delete it again."
  },
  "dev": {
    "kit": {
      "title": "Kit",
      "buttons": "Buttons",
      "fields": "Fields",
      "badges": "Badges",
      "icons": "Icons",
      "selection": "Chosen and inactive",
      "busy": "At work",
      "segment_fit": "Unit · by the width of words",
      "segment_inactive": "Unit · not now",
      "switch_off": "Off",
      "switch_on": "On",
      "switch_inactive_off": "Not now · off",
      "switch_inactive_on": "Not now · on",
      "checkbox_off": "Box unticked",
      "checkbox_on": "Box ticked",
      "checkbox_inactive_off": "Box unticked, not now",
      "checkbox_inactive_on": "Box ticked, not now",
      "cards": "Cards",
      "open_sheet": "Open the sheet",
      "open_long_sheet": "Open a long sheet",
      "long_sheet": "A long sheet",
      "open_states_sheet": "Open a sheet of states",
      "states_sheet": "States in a sheet",
      "open_wide_sheet": "Open a sheet of long names",
      "wide_title": "Electroequipmentofindustrialimplementations",
      "wide_meta": "Account «Raiffeisenbanksavingsaccountforholidaysandgifts»",
      "wide_line": "SOFT DRINK COCA-COLA ZERO 0.33L CAN PROMO 2+1 DISCOUNT 24.10.2026",
      "long_row": "Row {n}",
      "sample_milk": "Milk «Ashkhar»",
      "sample_meta": "UHT, 2.5%",
      "date": "Date",
      "scanned": "Read: {code}",
      "rows": "Rows and captions",
      "operations": "Operation row",
      "pace_day": "By September {day}",
      "skeleton": "Skeleton",
      "states": "States",
      "state_screen": "An error of the screen",
      "state_section": "As a section",
      "state_flow": "Under the words",
      "caption_month": "September 2026",
      "row_cash": "Cash, drams",
      "row_details_long": "Yesterday · A birthday present for a colleague, flowers and a cake · Tashir shopping centre",
      "row_short": "Cash",
      "row_short_meta": "Card",
      "row_card": "Ardshin card",
      "row_long": "Lori cheese, brined, from Shirak, by weight at the market counter",
      "row_long_meta": "The title wraps, and the meta keeps to two lines at most: anything longer ends in an ellipsis, so the row never grows without end",
      "row_whole": "An explanation — the meta whole",
      "row_whole_meta": "A step explains, and one cut by an ellipsis explains nothing: with whole the meta stands whole, in as many lines as it takes — as the newcomer’s steps on «What to buy» on a phone 320 wide",
      "row_warn": "Receipt of 27 Sep, 18:10",
      "row_warn_meta": "couldn’t be read — tone=\"warn\"",
      "row_good": "Yerevan City",
      "row_good_meta": "receipt already recorded — tone=\"good\"",
      "row_download_meta": "Acts at once — no chevron",
      "row_erase_meta": "Asks to confirm — no chevron",
      "row_link": "A link that goes on",
      "row_link_meta": "Opens a screen — with a chevron",
      "row_device": "iPhone · Safari",
      "row_device_meta": "Not pressable: its tail holds its own button",
      "note_plain": "The income currency and the spending currency are the same — no rate to count.",
      "note_warn": "The city is not on the list — the prices will be seen by you alone.",
      "strip": "Connection in one line",
      "strip_offline": "Offline · charts as of 14:05",
      "strip_offline_long": "Offline · settings as of 14:05. Changes can be saved once the internet is back",
      "strip_unanswered": "The list as of yesterday 21:40 — the server did not answer",
      "strip_refreshing": "Refreshing · the list as of yesterday, 21:40",
      "caption_goes_on": "Goes on",
      "caption_acts": "Acts at once or asks",
      "row_link_inactive": "A link while offline",
      "row_link_offline": "Opens once there is a connection",
      "search": "Search field",
      "search_clear": "«What to buy» · «Clear»",
      "search_scan": "«What did you pick up?» · scanner",
      "search_readonly": "Read-only",
      "search_sample": "cheese",
      "search_scanner": "The scanner in the field"
    },
    "login_seam": "Sign in for development",
    "login_insecure": "Signing in needs https: run make certs"
  },
  "error": {
    "invalid_amount": "That does not look like an amount",
    "invalid_quantity": "That does not look like a quantity",
    "invalid_rate": "That does not look like a rate",
    "invalid_score": "A rating runs from 1 to 5",
    "currency_mismatch": "Amounts in different currencies cannot be added",
    "unit_mismatch": "Prices in different units cannot be compared",
    "not_found": "Not found",
    "conflict": "That is already taken",
    "no_actor": "This device is no longer recognised",
    "trip_open": "Another entry is still open",
    "internal": "Something went wrong",
    "trip_context_required": "Set the entry’s city and currencies before sending",
    "login_unavailable": "This login request is no longer available. Start again",
    "login_forbidden": "Open sign-in from the app",
    "login_rate_limited": "Too many login requests. Try again in a minute",
    "login_disabled": "Telegram sign-in is not configured yet",
    "bot_unauthorized": "The bot could not authenticate",
    "exchange_in_future": "An exchange cannot be dated in the future",
    "income_in_future": "An income cannot be dated in the future",
    "spending_in_future": "A spending cannot be dated in the future",
    "spending_category_unknown": "There is no such category — choose another",
    "spending_category_taken": "A category with this name already exists",
    "money_account_in_future": "An account cannot start in the future",
    "money_account_taken": "An account with this name already exists — choose another name",
    "money_account_currency": "This account is in another currency",
    "money_account_currency_locked": "This account already has operations, so its currency cannot change. Add a new account for another currency",
    "transfer_in_future": "That day has not come yet",
    "transfer_account": "This account is gone or in another currency — choose another",
    "spending_of_transfer": "This is a transfer fee — it changes together with the transfer, in its sheet",
    "barcode_shape": "A barcode has 8, 12 or 13 digits",
    "barcode_check_digit": "The digits don't add up — check the code",
    "barcodes_full": "This item already holds twenty codes — no more can be added",
    "barcode_in_store": "This is a shop's own label — such a code is not saved to the catalogue",
    "receipt_not_photo": "This is not a photo of a receipt. Take it again",
    "receipt_too_large": "The photo is too large. Take the receipt again",
    "receipt_not_ready": "The receipt has not been read yet, so it cannot be recorded",
    "receipt_recorded_before": "This receipt has already been recorded",
    "receipt_in_future": "The receipt's date has not come yet",
    "receipt_total_required": "Enter the receipt's total — without it there is nothing to record",
    "receipt_link_invalid": "This is not a link from a Serbian tax receipt, or it is damaged",
    "feedback_rate_limited": "That is a lot of messages for today. Your text is saved — send it tomorrow",
    "feedback_picture_invalid": "The picture would not do — choose another one",
    "feedback_picture_too_large": "The picture is too large — choose another one",
    "client_errors_rate_limited": "Too many failure reports. Try again in a minute"
  },
  "settings": {
    "title": "Settings",
    "country": "Country",
    "countries": {
      "AM": "Armenia",
      "GE": "Georgia",
      "RS": "Serbia"
    },
    "city": "City",
    "spendCurrency": "Spending currency",
    "incomeCurrency": "Conversion currency",
    "currencies": {
      "AMD": "Armenian dram · AMD",
      "RUB": "Russian ruble · RUB",
      "USD": "US dollar · USD",
      "EUR": "Euro · EUR",
      "GEL": "Georgian lari · GEL",
      "RSD": "Serbian dinar · RSD"
    },
    "conversion_hint": "Shows what your purchases cost in this currency. This is not an income record.",
    "scope": "New settings apply to future entries. Entries already started keep their currency and rate.",
    "saved": "Settings saved",
    "save": "Save",
    "saving": "Saving…",
    "overwrite": "Apply my changes",
    "cancel": "Discard changes",
    "offline": {
      "title": "No connection",
      "body": "Settings will appear when the connection returns",
      "strip": "Offline · settings as of {when}. You can save changes when the internet returns.",
      "strip_untimed": "Offline · settings saved on this phone. You can save changes when the internet returns."
    },
    "context_missing": "This device has no confirmed settings yet. Connect to load them.",
    "conflict": {
      "title": "Settings changed on another device",
      "body": "Saved now: {country}, {city}; purchases — {spendCurrency}, conversion — {incomeCurrency}. Your edits are below. Apply them or discard to use saved settings."
    },
    "legacy": {
      "title": "Confirm this entry’s city and currencies",
      "body": "This entry started in an earlier version. Check where and in which currency you shopped. All items are waiting on this phone.",
      "action": "Review the entry’s settings",
      "confirm": "Confirm and send"
    },
    "group_place": "Where you live",
    "group_currencies": "Currencies",
    "city_hint": "Used for new entries and prices near you",
    "city_current": "Now: {city}",
    "city_not_listed": "This city is not in the list — keep it or choose an available one",
    "city_changed": "What to buy will show prices for the new city. Your previous purchases will stay.",
    "spend_hint": "The default for new entries. Each purchase can use a different currency.",
    "same_currencies": "The currencies match — no conversion needed",
    "changed": "changed",
    "changed_announced": "changed, not saved",
    "save_needs_network": "You can save when the connection returns",
    "save_unchanged": "Save · no changes",
    "stale_error": "The server did not answer · settings as of {when}",
    "stale_error_untimed": "The server did not answer · settings saved on this phone",
    "stale_loading": "Refreshing · settings as of {when}",
    "stale_loading_untimed": "Refreshing · settings saved on this phone",
    "draft": {
      "title": "You have unsaved changes",
      "volatile": "Changes will remain only while the app is open"
    },
    "load_error": {
      "title": "Could not load settings",
      "body": "Please try again"
    },
    "save_error": {
      "title": "Could not save changes",
      "body": "Your edits are still here. Please try again."
    },
    "save_unknown": {
      "title": "Connection lost while saving",
      "body": "We will check with the server when it returns. Your edits will stay here."
    },
    "group_account": "Account",
    "sign_out": "Sign out",
    "group_data": "Your data",
    "analytics": {
      "label": "Count me in the statistics",
      "hint": "Marks that you opened “What to buy”, the count of ratings and the measure of the search by your queries — this is how we learn whether Molvia is needed and whether the search finds what you need. Turn it off and past marks are deleted."
    },
    "export": {
      "label": "Download my data",
      "hint": "Your records, ratings and settings, in one file",
      "offline": "You can download it once you are back online",
      "busy": "Preparing the file…",
      "failed": "Could not prepare the file",
      "lost": "The connection dropped — try again once it is back",
      "ready": "The file is ready",
      "hand_over": "Save or send"
    },
    "group_money": "Money",
    "group_bot": "Bot",
    "group_scheme": "Theme",
    "scheme": {
      "system": "System",
      "light": "Light",
      "dark": "Dark",
      "hint": "Applies to this device only"
    },
    "tap": {
      "offline": "Cannot save without a connection — the switch comes back with it.",
      "save_failed": "Not saved. Check the connection and try again.",
      "unsure": "No answer came — we do not know whether it was saved. Checking again.",
      "waiting": "Saving — no answer yet. We will show it when it comes.",
      "load_error": "The setting could not be loaded."
    },
    "salary_shift": {
      "label": "Salary counts in the next month",
      "day": "From which day",
      "day_option": "from day {day}",
      "hint": "A salary received on this day or later counts in «Came in» of the next month. The day it came in and the account balances stay as they are."
    },
    "bot": {
      "hint": "Reminders and receipts"
    },
    "erase": {
      "label": "Delete my data",
      "hint": "Everything, for good"
    },
    "group_app": "About the app",
    "feedback": {
      "label": "Write to the developer",
      "hint": "A bug, an idea or a question. The reply comes in Telegram"
    }
  },
  "feedback": {
    "title": "Write to the developer",
    "title_error": "Report a problem",
    "kind_label": "About",
    "kinds": {
      "bug": "Broken",
      "idea": "Idea",
      "other": "Other"
    },
    "text_label": "Message",
    "placeholder": {
      "bug": "What you did and what went wrong",
      "idea": "What's missing",
      "any": "Write it as it is"
    },
    "attached": "Sent along:",
    "attached_build": "version {build}",
    "attached_screen": "screen “{screen}”",
    "attached_code": "code {code}",
    "attached_pictures": "{n} picture | {n} pictures",
    "picture": {
      "list": "Pictures with the message",
      "alt": "Picture {n}",
      "remove": "Remove picture {n}",
      "add": "Attach a picture",
      "adding": "Preparing the picture…",
      "hint": "Take a screenshot with the phone’s buttons and attach it from the gallery. Only what you attach is sent.",
      "unreadable": "The picture could not be opened — choose another one",
      "shape": "The picture is too narrow or too long — choose another one",
      "lost": "The pictures were not kept — attach them again",
      "too_many": "{n} of {total} fit — a message takes three pictures at most. Remove one to attach another"
    },
    "languages": {
      "ru": "Russian",
      "en": "English"
    },
    "platform": {
      "app": "{os}, app",
      "browser": "{os}, browser"
    },
    "systems": {
      "ios": "iOS",
      "ipados": "iPadOS",
      "android": "Android",
      "macos": "macOS",
      "windows": "Windows",
      "linux": "Linux",
      "other": "another system"
    },
    "send": "Send",
    "sending": "Sending…",
    "done": "Done",
    "need_kind": "Choose what it's about",
    "need_text": "Write a message or attach a picture",
    "need_network": "You can send it once online",
    "need_tomorrow": "You can send it tomorrow",
    "offline": "No connection. The text is saved — send it once you're back online",
    "unsupported": "The message has a character that can't be sent",
    "sent": {
      "title": "Thanks, we'll read it",
      "body": "If we reply, it will come in Telegram, from the Molvia bot"
    },
    "limit": {
      "title": "That's a lot of messages for today",
      "body": "The text is saved — send it tomorrow"
    },
    "failed": {
      "title": "Couldn't send",
      "body": "The text is still here — try again"
    }
  },
  "field": {
    "clear": "Clear",
    "left": "{n} character left | {n} characters left",
    "full": "That's the limit: {max} characters"
  },
  "privacy": {
    "title": "Data and privacy",
    "summary": "Your list of purchases is shown to nobody. Others see prices without your name and only in a shop where at least three people bought the item, and ratings only as an average of three people. The items, shops and barcodes you added, and your word about a receipt line, everyone sees — without your name too, but with no threshold. No ads, and no third-party trackers or analytics either.",
    "operator": {
      "title": "Who is responsible for the data",
      "text": "Molvia is made by Vladimir Sitchikhin — a private individual in Gyumri, Armenia — who is responsible for your data. To reach him — «Write to the developer» in the settings: the message goes to him in person."
    },
    "stored": {
      "title": "What we keep",
      "telegram": {
        "term": "Your Telegram account number",
        "text": "To recognise you on any device. Your name, username and photo are not kept."
      },
      "purchases": {
        "term": "Purchases",
        "text": "What, where, when and for how much. This is the most personal part: it shows where you go. Only you see your list of purchases. Others may see a price you paid, without your name and only in a shop where at least three people bought that item — and then the shop’s price may turn out to be yours."
      },
      "exchanges": {
        "term": "Money exchanges",
        "text": "How much you changed, of which currency and when, and the note of where, if you write one — your own rate is worked out from them. When you amend an exchange, the version before it is kept beside it for as long as the exchange itself. Only you see them."
      },
      "incomes": {
        "term": "Income",
        "text": "How much came in, in which currency, when and from where, and the note if you write one — your rate is worked out from these too. When you amend an income, the earlier version is kept beside it for as long as the income exists. Only you see it."
      },
      "spendings": {
        "term": "Spending outside shop purchases",
        "text": "How much, in what, when, in which category, and «what» and «where» if you write them — and your own categories. Spending in another currency keeps the rate of its day, and a past month the rate of its last day, worked out from your exchanges. Only you see it."
      },
      "receipts": {
        "term": "Receipts",
        "text": "The photo of a receipt you sent and what was read from it: the shop’s taxpayer number, the date, the lines and the total. Our own server reads it; if reading receipts by the Claude model is on for you, the whole photo goes to it — to Anthropic (see «Who the data goes to»). No other outside service sees the photo. A Serbian receipt comes as the link of its QR code, with no photo: the phone reads the QR code, and the shot does not leave it — see «A Serbian receipt by its link». On our server the photo is deleted as soon as you record the receipt, and a receipt left unrecorded goes whole 28 days after it was sent. Except a receipt the model did not read whole: its photo and what the model read are kept by the developer for up to 21 days after reading — after recording and after «Retake» too — to find why lines were not read and to fix the reading; then they are deleted. The developer gets a message in Telegram about such a receipt: the start of its number, the country, how many lines were not read and why — no products, sums or shop. Not in the nightly copy, not in the logs; your data copy shows what is kept, until when and why. Delete the receipt or your data, and they go with it. A photo sent to Anthropic lives there up to 30 days, or up to 2 years if its check flags it (see «Who the data goes to»). The item lines cut out of the photo (without the head, where your name may be printed, and without the total) are kept no longer than 28 days after recording — recognition learns from them; a receipt read by the model has no lines cut out. If you left the screen while a receipt was being read, the Molvia bot tells you in Telegram that it is ready: the message names the shop or the receipt’s date and the number of items — no sums, no products — and Telegram sees that message. Kept here: how you learned the receipt was ready — in the app or from the bot — and whether that message is off. A recorded receipt is kept while its record is in «Purchases»: delete the record, and ten minutes later the receipt goes too, with all its lines. Delete one purchase, and its line goes at once. With the record or the purchase goes your word on the line in the shop’s memory; if another purchase of yours at the same shop recorded the same line, the word is taken from it again — its item, price and day. Lines you chose not to record are deleted when you record the receipt."
      },
      "accounts": {
        "term": "Accounts",
        "text": "An account’s name, its currency, the «savings» mark, the balance on its start day and your checks against the fact — what you counted and what the app counted; for spending, income, exchanges and purchases — which account and how much was charged. The balance is not stored but worked out. Only you see it."
      },
      "places": {
        "term": "Shops",
        "text": "The names of the shops you give with your purchases — in the shared catalogue, without your name."
      },
      "barcodes": {
        "term": "Barcodes",
        "text": "A code you linked to an item, and when. The code itself is in the shared catalogue: everyone finds the item by it, but whose it is is shown to nobody."
      },
      "ratings": {
        "term": "Ratings and reviews",
        "text": "Only you see your review. Others see a rating only inside an average of three people. A rating you withdrew stays with us as a row without its review — why is said under «Statistics — with your consent». If two item cards turned out to be one and were merged, and a rating given by the old card landed over your rating of the other, the earlier one — its score and dates, without the review — is kept while the merge can be undone: undoing it brings that rating back."
      },
      "reminders": {
        "term": "Rating reminders",
        "text": "When the bot last reminded you to rate your purchases, and which reminder in a row it was — so that it writes less often if you do not answer. And whether the reminders are off — by you, or because you blocked the bot — and since when the bot is blocked. The message itself carries the item and the shop to Telegram: otherwise the question would not say what it is about."
      },
      "feedback": {
        "term": "Messages to the developer",
        "text": "What you wrote in «Write to the developer» or in reply to the developer’s answer in the Molvia bot, its kind, and what goes with the text: the app version, the screen, the phone’s system and whether it is the app or a browser, the language, and from an error screen its code. Screenshots, if you attached them yourself: everything in the file but the picture is removed before it is sent, where it was taken included. A screenshot is kept only until it reaches the developer in Telegram, and no longer than a week; Telegram sees it, as it sees the text, and a copy stays in the developer’s chat. And the developer’s replies, each with the number of the Telegram message it reached you as: that is how your answer joins the same conversation. Only the developer reads them. A copy of the message reaches the developer in Telegram without your name or account number, and stays in that chat even after the message is deleted here. Kept for a year from the last message of the conversation."
      },
      "search": {
        "term": "Search picks",
        "text": "What you took for which query, so that next time it comes first. And a query that found nothing, if you then found the item by another word — so that next time your word finds it. Other people do not see your pairs. With your consent, the developer measures the search by them, and a query that found nothing may join the search's shared dictionary — without your name, and only from three people; see «Statistics — with your consent»."
      },
      "visits": {
        "term": "Visit marks",
        "text": "Whether you opened “What to buy” — at most once a day. For the statistics only, and only with your consent — see «Statistics — with your consent»."
      },
      "devices": {
        "term": "Sign-in devices",
        "text": "The name of the phone and browser you signed in from, and when you last used them. The list is in Settings, under Devices, where any sign-in can be ended. A sign-in unused for six months is deleted by itself."
      },
      "settings": {
        "term": "Your settings",
        "text": "Country, city, currencies, and the day you changed the currency of conversion — and for “Count me in the statistics”: since when it is off, and when you last turned it back on. And when you last used the app or signed in to it: the two years of “An inactive account” are counted from that day. And when the bot last warned you that the account is about to be deleted — 30 or 7 days before: so that it does not warn twice."
      },
      "consent": {
        "term": "Consent to the terms",
        "text": "Which edition of the Terms of use and of this page you accepted, and when — so that we can ask you again when they change in a way that matters. We keep neither your age nor your date of birth."
      }
    },
    "bases": {
      "title": "Why, and on what basis",
      "text": "Almost everything in the list above is needed for Molvia to work: you accepted the «Terms of use», and that is our agreement. You cannot refuse this data and stay in Molvia — you can only delete the account.\nOne thing rests on your separate consent: the statistics, described in the next section.\nWhat we do with the data: receive it from you, keep it, show it to you, work out average ratings and prices for others from it — without your name, pass it to those named under «Who the data goes to», and delete it."
    },
    "statistics": {
      "title": "Statistics — with your consent",
      "text": "To learn whether people need Molvia, the developer counts two things: whether people come back — by the visit marks — and how many ratings are given, withdrawn ones included. He counts in numbers, without names and without what you rated.\nHe also measures the search: whether it puts first what people then take — by what you took for which query. For this the developer exports such pairs to himself — without your name or account number, the query as the search keeps it (no capitals, one spelling: «молоко» is moloko) — and deletes the export after the measure. Numbers go into the result, and one kind of word: a query that found nothing, where you then found the item by another word, may join the search's shared dictionary — without your name, and only if at least three people said the same.\nThe consent holds while «Count me in the statistics» is on in the settings — and it is on until you turn it off. You can turn it off at any moment: the visit marks are deleted at once and no new ones are written, and your ratings and queries stop being counted in that count. You can turn it back on in the same place: ratings and queries are counted again, those made while it was off too.\nApart from that, with no one’s name or number — only as numbers by day — we count how many sign-ins began and finished, how many receipts were read, how soon after sending they were recorded and how many of their lines were put right or left out, how many reminders went out, how many ratings were given in reply and how many times reminders were turned off — by the button, in the settings or by blocking the bot: this is how we see whether sign-in, receipt reading and reminders work. There is no one in these numbers, so the switch does not touch them.\nA rating you withdrew stays with us as a row — without its review, but with the rating itself and the moment you gave it: it is how the bot knows not to ask you to rate a purchase whose rating you withdrew. It stays after the statistics are turned off too, but is no longer counted, and it goes with the account."
    },
    "recipients": {
      "title": "Who the data goes to",
      "people": {
        "term": "Other people",
        "text": "Average ratings of three people and prices without your name — to those who have access to other people’s figures. With no access and no threshold of three, everyone sees the items, shops and barcodes you added to the shared catalogue, and your word about a receipt — which item stands behind a line and which shop it is: it is offered to anyone who reads a receipt of the same shop, even if only you said it. And, with your consent to the statistics, a query that found nothing — in the search's shared dictionary, if at least three people said the same. All of it without your name. Your list of purchases, your spendings and your money — to nobody."
      },
      "telegram": {
        "term": "Telegram",
        "text": "The bot’s messages to you — sign-in, reminders, “receipt read”, the developer’s replies, a notice of a data breach, a warning before an inactive account is deleted — and your messages to the developer with their screenshots. Telegram is a company abroad; this has to go to it because Molvia’s sign-in and bot work through Telegram — a channel you chose yourself by signing in."
      },
      "contabo": {
        "term": "Contabo, server in France",
        "text": "The host: the database lies on its server."
      },
      "cloudflare": {
        "term": "Cloudflare",
        "text": "Keeps the encrypted copies of the database in the EU; it has no key to them."
      },
      "open_food_facts": {
        "term": "Open Food Facts",
        "text": "Only an unknown barcode — not you."
      },
      "serbian_tax": {
        "term": "The Serbian tax office",
        "text": "The link of a Serbian receipt: the total, the time, the receipt number and the buyer’s number if the receipt names one — a firm’s or yours. Not your phone and not your sign-in."
      },
      "anthropic": {
        "term": "Anthropic: USA and other countries",
        "text": "The whole photo of a receipt — only if reading receipts by the Claude model is on for you; the photo may print your name if the shop prints it. Anthropic stores what is sent in the USA and computes it in any country where it has capacity; which one, we do not know in advance either. The model gives back the lines, the total and the shop, and they are kept by us, as any receipt read. At Anthropic the photo and the model’s answer live up to 30 days, or, if its automated check flags the request as breaking its rules, up to 2 years, and the score of that check up to 7 years. This is a transfer abroad, and it rests on your consent to this edition: without it a receipt is read by our own server alone. Under Anthropic’s terms for its API, what is sent is not used to train its models."
      },
      "nobody": {
        "term": "Nobody else",
        "text": "We do not sell the data and do not give it to advertisers."
      }
    },
    "logs": {
      "title": "Server logs",
      "text": "Kept for no longer than 14 days. Requests are written to them without your IP address and without what you searched for. An IP address can reach the server's error log — and it too lives there no longer than 14 days — and the server's memory along with an app failure: see «App failures». And the server keeps metrics: how many requests reached each part of it and how fast it answered — every 15 seconds, without a name, an address or what you searched for: this is how we see whether something broke. The last 30 days of them can be read, and they leave the disk month by month — within two months."
    },
    "failures": {
      "title": "App failures",
      "text": "When something in the app breaks, the phone sends the developer the kind of error, the screen it happened on, the app version and the phone’s system — none of your data: not what you typed, not your purchases, not your account. The phone’s address is not recorded in the database: the server keeps it in memory for an hour after the last failure sent from that address, so that no single address can send too many. With no connection it waits on the phone. Kept for 30 days."
    },
    "backups": {
      "title": "Where the data and its copies are",
      "text": "The server is in France, with the host Contabo. Once a day the database is copied, encrypted, to Cloudflare storage in the EU; only the owner of Molvia can decrypt a copy. Copies live 14 days — fourteen days after erasure your data is gone from them too. If the server ever has to be restored from a copy, an erasure made less than a day before the failure may need repeating. Receipt photos, the lines cut out of them and the screenshots sent to the developer are not copied. Armenian law allows keeping the data in France without a separate permission: France is on its list of countries with adequate protection, and without the server there is no service."
    },
    "barcodes": {
      "title": "An unknown barcode",
      "text": "If the catalogue does not know a scanned code, the server asks Open Food Facts, an open database of products, about it. Only the code itself and our server's address go there: not you, not your phone and not your sign-in. A shop's own label code never goes there. The name and size from there are only a hint, which you confirm or correct; items suggested with a code Open Food Facts knows are marked. The link «Data from Open Food Facts» opens the product's page there — from your phone, when you tap it. Open Food Facts data is open under the ODbL licence: we will send an export of what the catalogue took from there on request."
    },
    "serbian_receipts": {
      "title": "A Serbian receipt by its link",
      "text": "You hand over a Serbian receipt as the link of its QR code, with no photo: your phone reads the QR code off the shot, and the shot stays on it and is kept nowhere — or you paste the link yourself. The receipt is kept by the Serbian tax office (Poreska uprava), and our server takes its lines from there: it sends the tax office that link, then opens the receipt’s page by it and asks for the list of products — with the receipt’s number and a key from that very page — for the products’ codes. The tax office sees the link and our server’s address — not you, your phone or your sign-in. The link carries the receipt’s total, time and number, and the buyer’s number if the receipt names one — a firm’s or yours; the tax office holds all of it already. Of its answer we keep the seller’s tax number, the shop’s code and name, the town, the lines — with the products’ codes where the shop passed them on — the total and the time; the cashier’s name, the buyer’s number and the way of payment we do not take. A product’s code from the receipt becomes a barcode in the shared catalogue only if you tap «Link and record». We also keep whether the phone read the QR code or the link was pasted, and whether the camera missed before — that is how we see whether the QR code reads well. The link itself is erased as soon as the tax office answers, and never written to logs. A receipt just printed shows up there in a couple of minutes: the server asks again for two days, then says the receipt was not found."
    },
    "storage": {
      "title": "Cookies and the phone's memory",
      "text": "Two cookies: the sign-in, and one more for five minutes while you sign in. The phone keeps what you saw last and what has not reached the server yet. All of it is needed for the app to work, so there is no banner. Signing out in Settings erases all of it from the phone."
    },
    "copy": {
      "title": "A copy of your data",
      "text": "In the settings — «Download my data»: a file with everything about you in the database, including the earlier versions of exchanges and incomes you corrected, the items you added to the shared catalogue, the barcodes you linked, the receipts read — without their photos — your messages to the developer — without their screenshots — and the earlier ratings kept until a merge is undone. A rating you withdrew is there too: without its review it stays with us — why is said under «Statistics — with your consent». What you removed and can still bring back is there as well, marked. The file holds no login keys."
    },
    "erase": {
      "title": "Delete everything",
      "text": "In Settings, «Delete my data», or send /delete to the bot you sign in with and confirm. Data is deleted from the database immediately and for good, and from the backups within 14 days: everything in the list above goes except the shops — they, the items you added to the shared catalogue, the barcodes you linked and the shops’ memory — which item stands behind a receipt line and the shelf price — stay, without your name. Deletion does not reach the receipt photos the Claude model read: at Anthropic they and the model’s answers live their own term — up to 30 days, up to 2 years if its check flagged them, the check’s score up to 7 years (see «Who the data goes to»). Deleting from Settings also erases the copies on the phone you deleted from; on other devices, and after /delete, they may remain: to remove them, delete the app there or clear the site's data — or sign out there in Settings beforehand. You can sign in again, but it will be a new, empty account. One number without a name remains after deletion: how many people who came in the same week as you deleted their data, and how many of those accounts were deleted by themselves, after two years without a visit. It is there so that whether Molvia gets used is counted honestly."
    },
    "inactive": {
      "title": "An inactive account",
      "text": "If you do not open Molvia for two years, the account is deleted by itself — just as by «Delete my data». The Molvia bot warns you 30 and 7 days before; to keep the account, opening the app is enough — and signing in, if it asks. If you have blocked the bot, there is no way to warn you, and the account is deleted without a warning."
    },
    "rights": {
      "title": "Your rights",
      "text": "To learn what is kept about you and get a copy — «Download my data». To correct — edit: a purchase’s quantity and sum, a record’s receipt total, and ratings, reviews, exchanges, incomes, spendings, accounts and settings. A purchase’s item and a record’s shop or day cannot be edited — delete such a record and enter it again. To delete everything — «Delete my data» or /delete in the bot. To withdraw the consent to the statistics — «Count me in the statistics». All of this works at once, with no request. If you need something else, write to the developer: the answer comes within five working days at most."
    },
    "complaints": {
      "title": "Where to complain",
      "text": "If you believe we have violated your rights to your data, you can complain to the data protection authority of your country: in Armenia — the Personal Data Protection Agency of the Ministry of Justice (pdpa.am), in Georgia — the State Audit Office (sao.ge), in Serbia — the Commissioner for Information of Public Importance and Personal Data Protection (poverenik.rs)."
    },
    "breach": {
      "title": "If the data leaks",
      "text": "If a stranger may have seen your data, we will say so at the top of this page — an installed app shows it once it updates — report it at once to the data protection authorities and to the Armenian police, and tell those it concerns through the Molvia bot: what happened, which data, and what to do."
    }
  },
  "terms": {
    "title": "Terms of use",
    "what": {
      "title": "What this is",
      "text": "Molvia is an app where people note what is worth buying, and where. It is made by Vladimir Sitchikhin — a private individual in Gyumri, Armenia. It is not a shop and not an advertisement."
    },
    "who": {
      "title": "Who may use it",
      "text": "You must be 16 or older. You sign in with your Telegram — there is no other way."
    },
    "yours": {
      "title": "Your records",
      "text": "Your purchases, spendings, exchanges and accounts are seen by you alone. Others see ratings and prices without a name, and only once at least three people have recorded them. In detail — «Data and privacy»."
    },
    "write": {
      "title": "What to write",
      "text": "What you bought and tried yourself. Do not write what you know to be false, or anyone else’s personal data — not in names, not in notes, not in messages to the developer."
    },
    "catalogue": {
      "title": "The shared catalogue",
      "text": "The items and barcodes you add become part of the shared catalogue and stay in it without your name, even if you delete your account."
    },
    "ads": {
      "title": "No advertising",
      "text": "There is no advertising and no paid placement in the answers — not now, not later."
    },
    "warranty": {
      "title": "No warranty",
      "text": "Ratings are people’s opinions, prices are what they recorded. The app is provided as is. What to buy is your decision."
    },
    "free": {
      "title": "Your own is free",
      "text": "Recording and seeing your own data is free, always. If access to other people’s figures ever becomes paid, a new edition will appear here, and the app will ask you again."
    },
    "changes": {
      "title": "Deletion and changes",
      "text": "You can delete everything at any time: in Settings, or with /delete in the bot. If the terms or «Data and privacy» change in a way that matters, the app will ask for your consent again the next time you open it."
    },
    "contact": {
      "title": "Contact",
      "text": "«Write to the developer» in Settings."
    }
  },
  "policy": {
    "revised": "Edition {version}, revised {day}"
  },
  "consent": {
    "title": "Terms and privacy",
    "body": "Your purchases are seen by you alone. Others see prices and ratings without a name, and only once at least three people have recorded them. The items, shops and barcodes you add, and your word about a receipt, everyone sees — without a name, but with no threshold. No ads, no trackers.",
    "updated": {
      "title": "The terms have changed",
      "body": "Read what changed and accept the new edition — you cannot go on without it.",
      "changes": "What changed"
    },
    "changes": {
      "2": "The person responsible for your data is named — Vladimir Sitchikhin, Gyumri. The statistics — visit marks and the count of ratings — now rest on your consent, and «Count me in the statistics» withdraws it. The edition before promised others see only what three people recorded — corrected: the items, shops and barcodes you added, and your word about a receipt line, everyone sees, without your name but with no threshold. Added: your rights, where to complain, who the data goes to — the Serbian tax office among them, for receipts by link — how long an inactive account is kept, and what we do if the data leaks.",
      "3": "A new recipient — Anthropic (USA): for those who have reading receipts by the Claude model on, the whole photo of a receipt goes to it, and the photo may print the buyer’s name. Until you accept this edition, your receipts are read by our own server alone.",
      "4": "A new purpose: if the model did not read a receipt whole, the developer keeps its photo and what the model read for up to 21 days after reading — after recording or a retake too — to find why lines were not read, and gets a message about it in Telegram, with no products, sums or shop. Until you accept this edition, the photo of your receipt is deleted when you record it, as before.",
      "5": "Where your data is. The Molvia server is in France, not in Germany as the edition before said. Anthropic stores a receipt’s photo in the USA and computes it in any country where it has capacity, and keeps the photo and the model’s answer up to 30 days (up to 2 years if its check flags them, and the check’s score up to 7 years). Until you accept this edition, your receipts are read by our own server alone.",
      "6": "A new purpose: with your consent to the statistics, the developer measures the search by what you took for which query — without your name or account number — and deletes the export for the measure after it. Queries made before this edition are in the measure too. A query that found nothing may join the search's shared dictionary — without your name, and only if at least three people said the same. Until you accept this edition, your queries are not in the measure — nor are they while «Count me in the statistics» is off."
    },
    "statistics": {
      "title": "Statistics",
      "text": "We count whether people come back and how many ratings they give, and measure the search by what you took for a query — in numbers, without names; a query that found nothing may join the search's shared dictionary if at least three people said the same. Your visit marks, ratings, withdrawn ones included, and queries are in that count while «Count me in the statistics» is on. You can turn it off in the settings at any moment."
    },
    "age": "I am 16 or older",
    "accept": "I accept",
    "accept_busy": "Saving…",
    "decline": "I do not accept",
    "offline": "You cannot accept without the internet — connect, and the button will work.",
    "error": "Could not save your consent. Try again.",
    "failed": {
      "title": "Could not open the terms",
      "body": "The server did not say whether you have accepted the terms. Try again."
    },
    "lost": {
      "title": "No connection",
      "body": "Checking whether you have accepted the terms needs the internet. The screen will try again by itself when the connection is back."
    },
    "leave": {
      "title": "Molvia cannot be used without consent",
      "body": "Your account already exists: it holds your Telegram id and everything you recorded before. You can sign out — and come back when you decide. Or you can delete all your data now.",
      "erase": "Delete my data…",
      "back": "Back to the terms"
    }
  },
  "accounts": {
    "title": "Accounts",
    "all": "All",
    "more": "{n} more account | {n} more accounts",
    "savings_tag": "savings",
    "total": "Total",
    "total_foot": "Spendable {spendable} · savings {savings}",
    "stale": "Offline · balances as of {when}",
    "unassigned": "{n} entry isn't in any balance | {n} entries aren't in any balance",
    "load_failed": "Couldn't load balances",
    "done": "Done",
    "savings": "Savings",
    "for_spending": "For spending",
    "balance": "Balance",
    "no_operations": "No entries yet",
    "currency_spending": "{currency} · for spending",
    "currency_savings": "{currency} · savings",
    "error_body": "The server didn't answer. Nothing you saved is lost — try again",
    "offer": {
      "title": "Where is your money?",
      "body": "Add cash and cards — balances will keep themselves up to date"
    },
    "unassigned_sheet": {
      "title": "Not in any balance",
      "meta": "No account since the last check. Pick one and the balance updates",
      "all_done": "Every entry has an account"
    },
    "screen": {
      "spendable": "Spendable",
      "rate": "At my rate: {rates}",
      "row_checked": "{currency} · checked {date}",
      "row_started": "{currency} · started {date}",
      "row_open": "Open account:",
      "add": "Add account",
      "archived": "Put away ({n})",
      "archived_row": "{currency} · {amount} · put away {date}",
      "archived_note": "A put-away account isn’t offered for new spending, income or exchanges. Its history and balance are kept",
      "restore": "Restore",
      "restoring": "Restoring…",
      "restore_wait": "Will bring back once online",
      "restored": "“{name}” is back in the list",
      "removed": "Deleted: {name}",
      "removed_announced": "Deleted: {name}. Undo within 10 seconds",
      "archived_done": "“{name}” put away — find it under “Put away”",
      "offline": "Offline · balances as of {when}. Accounts and checks wait for a connection",
      "unanswered": "The server did not answer · balances as of {when}",
      "empty": {
        "body": "Add cash and cards — balances will follow your spending, income, exchanges and purchases"
      },
      "error": {
        "title": "Couldn't load accounts"
      },
      "offline_empty": "The accounts will show once the connection is back",
      "uncounted": "{n} account not counted — no rate | {n} accounts not counted — no rate",
      "rate_official": "At the {bank} rate: {rates}",
      "rate_mixed": "At the day’s rates: {rates}",
      "restore_late": "Too late: “{name}” is deleted for good",
      "restore_failed": "The account didn’t come back — check the connection and tap “Undo” again",
      "rate_banks_and": " and ",
      "transfer": "Transfer between accounts"
    },
    "account": {
      "edit": "Edit",
      "approx": "{amount} at my rate",
      "balance_hidden": "Balance hidden while you reconcile",
      "started": "started at {amount} on {date}",
      "checked": "checked {date}",
      "operations": "Entries",
      "more": "{n} more entry for {range} | {n} more entries for {range}",
      "charged_sub": "{amount} · charged",
      "no_charged_sub": "{amount} · no “charged”",
      "exchange": "Exchange",
      "exchange_from": "from “{name}”: {amount}",
      "exchange_to": "to “{name}”: {amount}",
      "reconcile_row": "Other · check",
      "reconcile_out": "spending from a check",
      "reconcile_in": "income from a check",
      "empty": {
        "body": "Spending, income, exchanges and purchases on this account will show up here. For now the balance is the start"
      },
      "reconcile": "Check against reality",
      "not_found": "No such account",
      "to_list": "To accounts",
      "title": "Account",
      "unanswered": "The server did not answer",
      "error": {
        "title": "Couldn't load the account"
      },
      "row_open": "Open entry:",
      "archived": "Taken out of the choice on {date}. Its history and balance stay",
      "transfer": "Transfer"
    },
    "sheet": {
      "title_add": "New account",
      "title_edit": "Account",
      "meta_add": "Where the money is — only you can see this",
      "meta_has_ops": "Has entries · started {date}",
      "name": "Name",
      "name_placeholder": "Cash ֏",
      "currency": "Currency",
      "currency_option": "{name} · {code}",
      "kind": "What for",
      "kind_hint": "Savings aren't counted as spendable",
      "start_day": "As of",
      "start_hint": "Today — the balance when the account was made: everything recorded on it after changes it. A past day — the balance that evening",
      "start_amount": "Held at the start",
      "start_now": "now {amount}",
      "save": "Save",
      "saving": "Saving…",
      "wait_online": "Will save once online",
      "offline": "Offline. Accounts change only with a connection — what you typed stays here",
      "added": "Account “{name}” added",
      "saved": "Account saved",
      "failed": "Couldn't save the account — try again",
      "conflict": "The account changed on another device",
      "no_name": "Name the account",
      "name_taken": "“{name}” already exists — pick another name",
      "bad_start": "Enter a balance — 0 is fine",
      "delete": "Delete account",
      "deleting": "Deleting…",
      "delete_offline": "Will delete once online",
      "delete_note": "No entries yet — it will be deleted for good. You can undo for 10 seconds",
      "archive": "Put away",
      "archiving": "Putting away…",
      "archive_offline": "Will put away once online",
      "archive_note": "History and balance stay; the account moves to “Put away” and can be restored"
    },
    "reconcile": {
      "title": "Reconciliation",
      "meta": "{name} · {currency}",
      "question": "How much is there right now?",
      "hint": "Count the cash or look in the bank. We'll show what the app counts afterwards — so you don't adjust to it",
      "no_fact": "Enter an amount — 0 is fine",
      "check": "Check",
      "checking": "Checking…",
      "wait_online": "Will check once online",
      "offline": "No connection. You can reconcile once online — what you typed stays here",
      "offline_result": "No connection. The check is counted — the difference can be recorded once online",
      "offline_counted": "No connection. The check is counted",
      "match_title": "Matches the app",
      "match_body": "We'll remember this check for today, {date}. The next one starts from here",
      "mismatch": "The app counts {app}, the account has {fact}",
      "difference": "Difference",
      "edit_fact": "Enter another amount",
      "causes_title": "What could explain it since {date}",
      "causes_hint": "Fix an entry — the difference updates",
      "cause_no_account_spending": "Spending {amount} with no account",
      "cause_no_account_income": "Income {amount} with no account",
      "cause_no_account_exchange": "Exchange {amount} with no account",
      "cause_no_charged": "{title} in {sign} with no “charged”",
      "cause_no_charged_meta": "{amount} · {date} · counted at the day's rate",
      "cause_trip_unpriced": "Purchases on {date} with no total",
      "cause_trip_unpriced_meta": "{place} · {n} item without a price | {place} · {n} items without a price",
      "no_causes_title": "Looks like some spending wasn't recorded",
      "no_causes_body": "Since {date} every entry {currency} has an account, amounts and “charged” are in place. Think of what you might have paid outside the app",
      "write_difference": "Record the difference as “Other · check”",
      "writing": "Recording the difference…",
      "write_wait_online": "Will record once online",
      "write_after_recount": "Will record after the recount",
      "write_after_answer": "Will record after your answer in Purchases",
      "retry_wait_online": "Will retry once online",
      "retry_after_recount": "Will retry after the recount",
      "retry_after_answer": "Will retry after your answer in Purchases",
      "write_out_note": "We'll record spending of {amount} on “{name}”",
      "write_in_note": "We'll record income of {amount} “Other” on “{name}”",
      "recounting": "We will count again once the corrections reach the server",
      "trips_held": "An entry is waiting for your answer in Purchases — record the difference after it: until then the server counts without it",
      "recounted": "Saved — difference updated",
      "written": "Recorded “Other · check”: {amount}",
      "saved_match": "Check saved",
      "saved_mismatch": "Check saved, a difference remains",
      "note": "check",
      "cause_no_account_trip": "Purchases {amount} with no account",
      "cause_uncounted": "{title} — no rate to count it by",
      "no_other": "The categories did not load — the difference needs “Other” to be recorded",
      "failed": "Couldn’t check the account — try again"
    },
    "picker": {
      "row_spending": "Account",
      "row_income": "To account",
      "row_given": "Paid from",
      "row_received": "Received to",
      "row_trip": "Purchases account",
      "row_open": "Choose account:",
      "none": "No account",
      "none_hint": "Doesn't move any balance",
      "meta": "Balances as of now",
      "group_same": "Accounts {currency}",
      "group_other": "Other currencies",
      "note_loose": "An account in another currency adds a “Charged to account” field",
      "note_strict": "Only accounts {currency}: money comes and goes in the account's currency",
      "note_strict_none": "No accounts {currency} — the entry will have no account",
      "trip_saved": "Purchases account: {name}",
      "trip_saved_none": "Purchases account: none",
      "note_transfer_to": "Only accounts {currency}, except «{name}». Moving to another currency is an «Exchange»",
      "note_transfer_from": "An account in another currency — «To» will need choosing again"
    },
    "charged": {
      "label": "Charged to account, {sign}",
      "hint_empty": "Empty — we'll use the day's rate, about {amount}",
      "hint_filled": "“{name}” goes down by exactly {amount}",
      "hint_empty_plain": "Empty — it will be counted at the rate of the day"
    },
    "trip_hint": "Items without a price don’t reduce the balance. Prices are edited in Purchases, the account here — the choice saves right away",
    "trip_unpriced": "no price",
    "currency_in": {
      "AMD": "in drams",
      "RUB": "in roubles",
      "USD": "in dollars",
      "EUR": "in euros",
      "GEL": "in lari",
      "RSD": "in dinars"
    },
    "held_hint": "Accounts on {date}: {amount}",
    "held_fill": "Fill in",
    "card_from": "from “{name}”",
    "card_to": "to “{name}”",
    "card_name": "“{name}”",
    "stale_error": "Couldn’t refresh — balances as of {when}"
  },
  "update": {
    "ready": "A new version is out",
    "apply": "Update",
    "applying": "Updating…",
    "failed": {
      "title": "The update did not take",
      "body": "Close Molvia completely and open it again. iPhone: swipe it up in the app switcher. Android: Recents — swipe Molvia away."
    }
  },
  "scanner": {
    "title": "Barcode",
    "hint": "Point the frame at the barcode",
    "torch_on": "Turn on the torch",
    "torch_off": "Turn off the torch",
    "manual": "Type it in",
    "scan": "Scan",
    "field": "Digits under the barcode",
    "done": "Done",
    "try_again": "Check again",
    "insecure_title": "The camera needs a secure connection",
    "insecure_body": "Open the app at an https address — or type the code's digits in.",
    "denied_title": "No access to the camera",
    "denied_body": "iPhone: Settings → Apps → Safari → Camera → “Allow”. Android: the icon left of the address → Permissions → Camera. Or type the code's digits in.",
    "none_title": "No camera",
    "none_body": "This device has no camera. Type the code's digits in.",
    "error_title": "The camera did not start",
    "error_body": "Another app may be holding it. Close it and try again.",
    "reader_title": "The scanner is not responding",
    "reader_body": "Try again — or type the code's digits in.",
    "camera_hint_title": "Camera without asking",
    "camera_hint_app_body": "Safari asks for the camera every time Molvia starts. To stop it asking, allow the camera in Settings:",
    "camera_hint_app_path": "Settings → Apps → Safari → Camera → “Allow”",
    "camera_hint_app_search": "Quicker: search Settings for “Safari”.",
    "camera_hint_app_price": "This allows the camera for every website in Safari, not only Molvia.",
    "camera_hint_app_otherwise": "If nothing is changed, Safari will ask on every start — then just answer it “Allow”.",
    "camera_hint_tab_body": "Safari asks for the camera every time the page loads again. To stop it asking, allow the camera for this website:",
    "camera_hint_tab_path": "The page menu by the address bar → Website Settings → Camera → “Allow”",
    "camera_hint_tab_or": "Or for every website: Settings → Apps → Safari → Camera → “Allow”.",
    "camera_hint_tab_price": "This allows it for Molvia only.",
    "camera_hint_tab_otherwise": "If nothing is changed, Safari will ask after every reload — then just answer it “Allow”.",
    "camera_hint_ok": "Got it",
    "camera_hint_offer": "Safari asks every time? How to stop it"
  },
  "budget": {
    "title": "Budget",
    "offline_strip": "Offline · budget as of {when}",
    "error_strip": "The server did not answer — budget as of {when}",
    "offline_body": "This month's budget has not been loaded on this phone yet. It will appear once the connection is back",
    "load_error": {
      "title": "The budget did not load",
      "body": "The month's plan and spendings did not come. Try again"
    },
    "empty": {
      "title": "No plan yet",
      "body": "Set how much you are ready to spend on a category a month — as a sum or a share of what came in. The plan carries over to the next months by itself"
    },
    "total": {
      "left": "Left of the plan",
      "over": "Over the plan",
      "planned": "Plan",
      "unplanned": "Outside the plan",
      "not_whole": "Not all counted: some spendings or incomes have no rate",
      "awaiting": "A share of income comes once something comes in this month",
      "planned_more": "{amount} and more"
    },
    "row": {
      "of": "{spent} of {planned}",
      "share": "{percent} % of income",
      "over": "over the plan",
      "awaiting": "nothing came in yet",
      "archived": "category removed"
    },
    "unplanned": "No plan",
    "add": "Set a category plan",
    "add_offline": "Setting a plan needs a connection",
    "savings": {
      "title": "Put aside",
      "target": "Target — {percent} % of income",
      "no_target": "No target set",
      "so_far": "{percent} so far",
      "of": "Difference {difference} of {income}",
      "no_income": "Nothing has come in this month yet",
      "not_whole": "Cannot count: some spendings or incomes have no rate"
    },
    "entry": {
      "none": "not set",
      "left": "{amount} left",
      "over": "{amount} over"
    },
    "saved": "Plan «{name}» saved",
    "removed": "Plan «{name}» removed",
    "sheet": {
      "meta": "Plan for a month",
      "title_choose": "New plan",
      "kind": "How to set the plan",
      "kind_amount": "Sum",
      "kind_share": "% of income",
      "amount": "Sum a month",
      "percent": "Share of income",
      "amount_hint": "How much you are ready to spend on this category in a month",
      "share_hint": "A share of the month's «Came in» at the month's rate: more comes in — the plan grows too",
      "savings_hint": "How much of what came in you want to keep. Compared with «came in − went out»",
      "from": "From {month} on. {before} stays as it was",
      "bad_amount": "Enter a sum, for example 250 000",
      "bad_percent": "Enter a whole number from 0 to {max}",
      "category_gone": "This category is gone — refresh the screen",
      "failed": "Not saved. Try again",
      "offline": "Offline · a plan is saved with a connection",
      "save": "Save",
      "saving": "Saving…",
      "save_offline": "Saving needs a connection",
      "remove": "Remove the plan",
      "removing": "Removing the plan…",
      "remove_offline": "Removing needs a connection",
      "other_currency": "The plan was {amount}, before the spending currency changed. Enter a sum in {sign}",
      "too_big": "Too large a sum for a month's plan"
    }
  },
  "place": {
    "quoted": "«{place}»",
    "in_city": "{place} {where}",
    "in_unknown_city": "{place} ({city})",
    "cities_in": {
      "Гюмри": "in Gyumri",
      "Ереван": "in Yerevan",
      "Тбилиси": "in Tbilisi",
      "Батуми": "in Batumi",
      "Белград": "in Belgrade",
      "Нови-Сад": "in Novi Sad"
    }
  },
  "receipt": {
    "edges": {
      "title": "Receipt edges",
      "hint": "Drag the corners to the receipt's edges. For a part of a long receipt — to the overlap line",
      "not_found": "Couldn't find the edges — drag the corners to the receipt's edges yourself",
      "flat": "The corners don’t make a receipt — spread them to its edges",
      "corner": "Corner: {corner}. Move it with the arrow keys",
      "corners": {
        "top_left": "top left",
        "top_right": "top right",
        "bottom_right": "bottom right",
        "bottom_left": "bottom left"
      },
      "turn": "Rotate",
      "done": "Done",
      "narrow": "The receipt is small — move closer or take it in parts",
      "closer": "Move closer",
      "keep": "Keep it"
    },
    "capture": {
      "title": "Photograph a receipt",
      "hint_flat": "Smooth the receipt out and lay it on something dark",
      "hint_top": "Shoot from above — the whole receipt in frame, no glare",
      "hint_parts": "A long one — in parts, top to bottom, with a little overlap. Up to four parts",
      "take": "Take photo",
      "pick": "Choose photo",
      "one_part": "A short receipt needs one photo. A long one — take the next part with a little overlap",
      "parts_order": "Parts go top to bottom. Tap a part to retake or remove it",
      "parts": "{n} part | {n} parts",
      "part": "Part {n}",
      "part_of": "Part {n} of {total}",
      "part_aria": "Part {n}: retake or remove",
      "add_part": "Next part",
      "max": "Four parts is the limit. If the receipt didn’t fit, retake the parts from a little further away",
      "retake": "Retake",
      "remove_part": "Remove part",
      "offline": "No connection — the photos wait on your phone and go by themselves",
      "bad_file": "This file didn’t open as a photo. Choose a picture of the receipt — or take a new one",
      "not_kept": "The photo wasn’t kept on this phone. Free some space and try again",
      "preparing": "Preparing the photo…",
      "send": "Send receipt",
      "send_busy": "Sending the receipt…",
      "send_offline": "We’ll send it once you are online",
      "sent": "Receipt sent",
      "sent_offline": "The receipt is waiting for a connection — we’ll send it"
    },
    "sheet": {
      "photos": "Receipt photos"
    },
    "review": {
      "title_loading": "Receipt",
      "title_no_place": "Receipt from {day}",
      "title_sent": "Receipt sent {day}",
      "place_line": "{city} · TIN {inn} · {day}",
      "place_line_time": "{city} · TIN {inn} · {day}, {time}",
      "place_line_no_tin": "{city} · {day}",
      "sent_day": "{day}, the day it was sent",
      "place_missing": "Place not read · set it",
      "count_hint": "{count} · tap to fix",
      "tag_new": "new item",
      "tag_check": "check",
      "tag_skip": "not saved",
      "tag_added": "added",
      "issues_check": "to check: {n}",
      "check_note": "on the receipt — “{text}”",
      "qty_price": "{qty} × {price}",
      "unread": "The figures weren’t read — see the receipt",
      "qty_price_discount": "{qty} × {price} − {discount}",
      "packed": "· {pack}",
      "packed_spoken": "{figures}, recorded as {pack}",
      "mismatch": "≠ {printed}",
      "lines": "Lines",
      "total": "Receipt total",
      "total_missing": "Total not read · set it",
      "cashback": "Cashback to the card",
      "redeemed": "Paid with the card’s bonus",
      "repaired_note": "Figures put right — check them against the paper",
      "approx": "≈ {amount} at the {day} rate",
      "diff": "{amount} off — probably in the “{line}” line. You can save it anyway",
      "diff_unknown": "{amount} off — we couldn’t find the line. You can save it anyway",
      "diff_blank": "{amount} short — {n} line has no figures. You can save it anyway | {amount} short — {n} lines have no figures. You can save it anyway",
      "photo_note": "We delete the photo after saving — the lines stay",
      "photo_note_sum": "We delete the photo after saving",
      "partly_total": "Not all of it was read: the lines make {lines} of {total}, {short} short. If the print is faint, a retake will not help — correct the lines",
      "no_items": "This receipt lists no items — we will save its total. You can add the purchases later, in the record",
      "partly_read_total": "Not all of it was read: the lines make {lines} of about {total}, about {short} short. If the print is faint, a retake will not help — correct the lines",
      "partly_lines": "Not all of it was read: {n} of {total} lines add up. If the print is faint, a retake will not help — correct the lines",
      "partly_check": "Not all of it was read — check the lines against the paper. If the print is faint, a retake will not help: add what is missing later, in the record",
      "to_developer": "Send the receipt to the developer",
      "record": "Save {n} purchase | Save {n} purchases",
      "record_busy": "Saving…",
      "record_sum": "Save the total",
      "record_offline": "We’ll save it once you are online",
      "recording": "We’ll save it once you are online — the lines are kept on this phone",
      "cancel_record": "Cancel saving",
      "cancel_record_busy": "Checking…",
      "cancel_record_offline": "You can cancel once online: the record may already have reached the server",
      "cancel_record_failed": "The server did not answer — try cancelling again",
      "refused": "Not saved: {reason}. Fix it and save again",
      "offline": "Offline · receipt from this phone. Line edits are kept here",
      "unanswered": "The server did not answer · receipt from this phone. Line edits are kept here",
      "error": {
        "title": "The server didn’t answer",
        "body": "The receipt is safe. Any line edits are kept on this phone"
      },
      "line_aria": "{name}, {qty}, {sum}",
      "from_tax_office": "Lines from the Serbian tax office. No need to check them against the paper.",
      "place_line_pib": "{city} · PIB {inn} · {day}",
      "place_line_pib_time": "{city} · PIB {inn} · {day}, {time}"
    },
    "added": {
      "add": "Add a line",
      "title": "New line",
      "meta": "It is not among the lines read — type it from the paper",
      "item_missing": "Pick an item — a line cannot be recorded without one",
      "figures_note": "May be left empty: only the item is required",
      "remove": "Remove the line",
      "done": "Done",
      "full": "No more than {max} lines can be added"
    },
    "line": {
      "title": "Receipt line",
      "meta": "{n} of {total} · {place}",
      "meta_no_place": "{n} of {total}",
      "printed": "As printed",
      "translation": "Translation: {text}",
      "product": "Item",
      "product_other": "Change",
      "check_warn": "Not a sure match: the receipt says “{text}”. Check the item or pick another",
      "name": "Name it",
      "name_note": "The catalogue has no such item — saving adds it",
      "spelled_note": "Words our dictionary lacks are spelt in the receipt's letters",
      "unspell": "Drop the name — keep it as printed",
      "find": "Find in the catalogue",
      "price": "Price for all, as on the receipt",
      "weight_hint": "{qty} × {price} — we work out the unit price",
      "mismatch": "The receipt says {printed} for this line, but {qty} × {price} is {sum}. Fix the price or quantity — or leave it: it doesn’t stop saving",
      "remembered": "Last time it was {price} here — check the digits",
      "save": "Save",
      "skip": "Don’t save this line",
      "unskip": "Save this line",
      "skipped": "This line isn’t saved. It stays in the receipt sum — it was paid for",
      "discount_hint": "On the receipt: {price} − {discount}"
    },
    "pick": {
      "title": "Pick an item",
      "meta": "For the line “{printed}”",
      "meta_translation": "For the line “{printed}” · translation “{text}”",
      "meta_added": "For the line you are adding",
      "keep_new": "Keep as a new item “{text}”",
      "keep_new_note": "Saving adds it to the catalogue",
      "note": "Items come from the catalogue only: the same Save button adds a new one",
      "bad_name": "This name won’t do — make it shorter"
    },
    "place": {
      "title": "Where was it?",
      "missing": "The place wasn’t read on the receipt",
      "read": "Read: {place}, {city}",
      "when": "When",
      "city": "City",
      "done": "Done",
      "name": "Shop",
      "choose_place": "Choose the shop",
      "choose_day": "Choose the day"
    },
    "recorded": {
      "title": "Saved {n} purchase | Saved {n} purchases",
      "sum_title": "Saved the receipt total",
      "body": "Rate them at home, in Ratings. Any line can be fixed right now too",
      "to_verdicts": "To ratings",
      "from_receipt": "from a receipt",
      "printed_note": "Grey under each purchase — the line as printed. The photo is deleted"
    },
    "codes": {
      "title": "Link the barcodes?",
      "body": "The tax office passed on the products’ codes from the receipt. A linked code finds the product by the scanner — for you and for everyone who scans it",
      "skip": "Record without codes",
      "held": "Code {code} already belongs to «{name}» — it was not linked to the purchase"
    },
    "failed": {
      "meta": "{parts} · taken {day}, {time}",
      "title": "Couldn’t read it",
      "body": "The lines in the photo can’t be made out — faint print and glare do that. Add the purchases by hand or retake the receipt.",
      "reshoot_title": "Not one line found",
      "reshoot_body": "This happens when a receipt is crumpled, in shadow or faintly printed. Crumpled or in shadow — retake it: the receipt filling the frame, in parts if it is long; flattened with your palm; no shadow of your hand or phone. A retake will not fix faint print — add the purchases by hand.",
      "manual_body": "The lines in the photo can’t be made out. You can record the purchases by hand.",
      "photos": "Receipt photos · top to bottom",
      "photos_elsewhere": "The photo was taken on another phone — it isn’t here",
      "link": {
        "missing_title": "The tax office did not show the receipt",
        "missing_body": "We asked for two days. This happens when the till worked offline. You can record the purchases by hand.",
        "invalid_title": "The tax office does not accept this receipt",
        "invalid_body": "The tax office’s check says the receipt is not valid. You can record the purchases by hand.",
        "unreadable_title": "The receipt was not read",
        "unreadable_body": "You can record the purchases by hand or shoot the receipt’s QR code again."
      }
    },
    "duplicate": {
      "title": "This receipt was saved on {day}",
      "body": "It has the same number as a saved one. No need to save it twice — you can delete this one with its photo."
    },
    "gone": {
      "title": "This receipt is gone",
      "body": "It was deleted — perhaps on another phone.",
      "action": "To purchases"
    },
    "link": {
      "step_qr": "Point your phone’s camera at the QR code at the bottom of the receipt",
      "step_copy": "Open the link and copy the page’s address",
      "step_paste": "Paste it here",
      "field": "Link from the receipt",
      "refusal": {
        "not_link": "This is not a link from a Serbian receipt",
        "damaged": "The link is damaged — copy it again",
        "not_sale": "This is not a purchase receipt — copies, advance and training receipts are not recorded",
        "refund": "This is a refund receipt — it is not recorded"
      }
    },
    "qr": {
      "hint_qr": "Shoot the QR code at the bottom of the receipt — close and sharp",
      "hint_light": "Even light, no glare on the QR code",
      "hint_private": "Only the link in the QR code is sent — the photo stays on your phone",
      "have_link": "Already copied the link?",
      "paste_short": "Paste",
      "paste": "Paste the link",
      "take": "Shoot the QR",
      "reading": "Looking for the QR…",
      "missed_title": "No QR code found",
      "missed_body": "Come closer, so the QR code fills a third of the frame. Hold the phone until the camera focuses, and shoot in even light.",
      "retake": "Shoot again",
      "take_other": "Shoot another",
      "or_take": "The camera can read the QR code",
      "offline": "No connection — the link from the QR code goes by itself once there is one",
      "not_kept": "The link wasn’t kept: you are signed out. Sign in again and send the receipt once more"
    }
  },
  "transfer": {
    "title": "Transfer",
    "title_amend": "Edit transfer",
    "meta": "Between your own accounts in one currency. Not counted in the month's spending",
    "amount": "Amount",
    "from": "From",
    "to": "To",
    "pick": "Choose an account",
    "no_peer_value": "No {sign} account",
    "no_peer": "No other account {currency}",
    "fee": "Fee",
    "fee_hint": "Spending «Other» from «{name}»",
    "fee_hint_none": "Spending «Other» from the account you transfer from",
    "fee_total": "{amount} leaves in all",
    "day": "Day",
    "today": "Today",
    "note": "Note",
    "note_placeholder": "Optional",
    "amended": "edited {date}",
    "send": "Transfer {amount}",
    "sending": "Transferring…",
    "save": "Save",
    "saving": "Saving…",
    "need_from": "Choose where from",
    "need_peer": "Needs a second account {currency}",
    "need_amount": "Enter the amount",
    "need_to": "Choose where to",
    "wait_online": "We'll transfer once online",
    "wait_online_save": "We'll save once online",
    "offline": "No connection. You can transfer once online — what you've entered stays here",
    "failed": "The transfer didn't go through",
    "failed_retry": "Try again",
    "gone": "«{name}» was deleted on another phone. Choose another — the amount, fee and note are still here",
    "done": "Transferred: {amount} to «{name}»",
    "saved": "Transfer saved",
    "remove": "Delete transfer",
    "removing": "Deleting…",
    "remove_wait": "We'll delete once online",
    "remove_note": "Together with the fee. You can undo it right after",
    "removed": "Transfer deleted",
    "removed_sub": "Together with the fee",
    "restored": "Transfer restored",
    "restore_late": "Too late: the transfer is deleted for good",
    "restore_failed": "The transfer didn’t come back — check the connection and tap “Undo” again",
    "written_title": "The transfer is already recorded",
    "written": "The answer was lost, but {amount} to «{name}» is recorded. Save to write your figures over it — there will be no second transfer",
    "conflict_title": "The transfer was edited on another phone",
    "amend_conflict": "Recorded now: {details}. Save to write your figures over it",
    "current_fee": "fee {amount}",
    "unavailable": "The transfer didn’t open — the server didn’t answer",
    "unread_offline": "The transfer will open once you are online",
    "unread_gone": "Its rows have left the journal. If it was deleted just now, “Undo” on the screen brings it back",
    "vanished_title": "The transfer is gone — it was deleted",
    "vanished": "There is nothing to save. If it was deleted just now, “Undo” on the screen brings it back",
    "vanished_button": "Nothing to save",
    "removed_announced": "Transfer deleted with its fee. You can undo it",
    "row_out": "→ {name}",
    "row_in": "← {name}",
    "row_meta": "Transfer",
    "fee_row": "Transfer fee",
    "fee_row_meta": "Other · → {name}",
    "fee_spending": "Other · transfer fee"
  }
}
